<template>
    <div class="body-panel">
        <template v-if="project != null">
            <div class="body-panel-control separator">
                <div class="control-block-left">
                    <div class="flex">
                        <p class="btn-back margin-right-10">
                            <a class="router-link-active" href="" @click.prevent="$router.push('/projects')">Назад</a>
                        </p>
                        <p class="caption-help margin-right-10" v-if="project.new"> Новый проект</p>
                        <p class="caption-help margin-right-10" v-if="!project.new"> Редактирование </p>
                        <p class="caption-help margin-right-10">{{ project.Name }}</p>
                    </div>
                </div>
                <div class="control-block-right">
                    <div class="btns flex" data-toggle="buttons">
                        <button type="button" class="btn btn-primary" @click="saveProject()">Сохранить</button>
                        <button type="button" class="btn" @click="cancel()">Отмена</button>
                        <button type="button" class="btn btn-delete" v-if="!project.new && info.User && (info.User.MainRole === 'administrators')" @click="deleteProject()">Удалить</button>
                    </div>
                </div>
            </div>
            <div class="body-panel-content body-panel-content-page">
                <div class="block-in-page" v-if="!project.new">
                    <div class="flex btns" data-toggle="buttons" style="margin-right: 25px;">
                        <button type="button" class="btn" @click="onRoles">
                            Управление ролями
                        </button>
                        <button type="button" class="btn" @click="onUsers">
                            Управление пользователями
                        </button>
                        <button type="button" class="btn" @click="onTradePoints">
                            Торговые точки
                        </button>
                    </div>
                </div>
                <div>
                    <form action="#" @submit.prevent="saveProject" class="form-horizontal" novalidate="novalidate" autocomplete="off">
                        <div class="block-in-page closed">
                            <h2 class="margin-bottom-20 block-in-page-collapce">Основные настройки</h2>
                            <div class="block-in-page-detail">
                                <div class="form-field-group">
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Название
                                            <span class="required" aria-required="true">*</span>
                                        </label>
                                        <input name="Name" v-validate="'required'" v-model="project.Name" :class="['input-text', {'input-error': errors.has('Name')}]" type="text">
                                        <span class="field-validation-valid">{{ errors.first('Name') }}</span>
                                    </div>
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Название акции
                                            <span class="required" aria-required="true">*</span>
                                        </label>
                                        <input name="PromoName" v-validate="'required'" v-model="project.PromoName" :class="['input-text', {'input-error': errors.has('PromoName')}]" type="text">
                                        <span class="field-validation-valid">{{ errors.first('PromoName') }}</span>
                                    </div>
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Url адрес
                                            <span class="required" aria-required="true">*</span>
                                        </label>
                                        <input name="Subdomain" v-validate="'required'" v-model="project.Subdomain" :class="['input-text', {'input-error': errors.has('Subdomain')}]" type="text">
                                        <span class="field-validation-valid">{{ errors.first('Subdomain') }}</span>
                                    </div>
                                </div>
                                <div class="form-field-group">
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Начало программы
                                            <span class="required" aria-required="true">*</span>
                                        </label>
                                        <div class="input-date-lbl">
                                            <input-date name="StartDateFormatted"
                                                        v-validate="'required'"
                                                        v-model="project.StartDateFormatted"
                                                        @input="onChangeDate(project, 'StartDateFormatted', 'StartDate')"
                                                        :class="['input-text', {'input-error': errors.has('StartDateFormatted')}]"></input-date>
                                        </div>
                                        <span class="field-validation-valid">{{ errors.first('StartDateFormatted') }}</span>
                                    </div>
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Окончание программы
                                            <span class="required" aria-required="true"></span>
                                        </label>
                                        <div class="input-date-lbl">
                                            <input-date name="EndDateFormatted"
                                                        v-model="project.EndDateFormatted"
                                                        @input="onChangeDate(project, 'EndDateFormatted', 'EndDate')"
                                                        class="input-text"></input-date>
                                        </div>
                                        <span class="field-validation-valid">{{ errors.first('EndDateFormatted') }}</span>
                                    </div>
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Название css файла
                                        </label>
                                        <input name="CssFileName" v-model="project.CssFileName" placeholder="example.css" :class="['input-text', {'input-error': errors.has('CssFileName')}]" type="text">
                                        <span class="field-validation-valid">{{ errors.first('CssFileName') }}</span>
                                    </div>
                                </div>
                                <div class="form-field-group">
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Giftery Api Id
                                        </label>
                                        <div class="input-date-lbl">
                                            <input type="text" name="GifteryApiId" autocomplete="nope"
                                                   v-model="project.GifteryApiId"
                                                   :class="['input-text', {'input-error': errors.has('GifteryApiId')}]" />
                                        </div>
                                    </div>
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Giftery Secret Key
                                        </label>
                                        <div class="input-date-lbl">
                                            <input type="text" name="GifterySecretKey" autocomplete="off"
                                                   v-model="project.GifterySecretKey"
                                                   :class="['input-text', {'input-error': errors.has('GifterySecretKey')}]" />
                                        </div>
                                    </div>
                                    <div class="form-field">
                                        <label class="input-text-lbl">Расчет НДФЛ</label>
                                        <drop-down :items="filteredAdditionalValueFeeOptions"
                                                   :dataField="'Value'"
                                                   :textField="'Name'"
                                                   v-model="project.ValueAddedFee"></drop-down>
                                    </div>
                                </div>
                                <div class="form-field-group">
                                  <div class="form-field">
                                    <label class="input-text-lbl">Страна</label>
                                    <drop-down :items="countries"
                                               @change="onCountryChange"
                                               :dataField="'Id'"
                                               :textField="'Name'"
                                               v-model="project.CountryId"></drop-down>
                                  </div>
                                  <div class="form-field">

                                  </div>
                                  <div class="form-field">

                                  </div>
                                </div>
                                <!--<div class="form-field-group">
        <div class="form-field">
            <label class="input-text-lbl">Озон аккаунт</label>
            <drop-down :items="ozonAccounts"
                       :dataField="'Id'"
                       :textField="'Name'"
                       v-model="project.OzonApiCredentialId"></drop-down>
        </div>
    </div>-->

                                <div class="line-separator margin-bottom-15 margin-top-15"></div>
                                <label class="input-text-lbl">Логотип проекта:</label>
                                <div class="form-field margin-top-10 flex">
                                    <div class="form-field file-uploaded margin-right-20" v-if="project.Image && !deleteImage">
                                        <img :src="project.Image" />
                                        <button type="button" class="btn btn-delete margin-top-15" @click="removeImage()"
                                                v-if="project.Image && !deleteImage ">
                                            Удалить изображение
                                        </button>
                                    </div>
                                    <div class="form-field">
                                        <div class="file-upload-zone">
                                            <input type="file" id="dropFiles" ref="dropFiles" name="dropFiles"
                                                   class="file-upload-zone-btn" accept=".jpg,.jpeg,.png,.gif,.bmp" />
                                            <label id="dropFilesBtnLbl" for="dropFiles" class="file-upload-zone-lbl">
                                                Перетяните
                                                сюда изображение или нажмите, чтобы выбрать
                                            </label>
                                        </div>
                                        <div id="fileList" v-if="file != null" class="fileList">
                                            Выбран файл: {{file.name}}
                                        </div>

                                    </div>
                                </div>
                                <div class="line-separator margin-bottom-15 margin-top-15"></div>

                                <label class="input-text-lbl">Логотип для стартовой страницы:</label>
                                <div class="form-field margin-top-10 flex">
                                    <div class="form-field file-uploaded margin-right-20" v-if="project.StartImage && !deleteStartImage">
                                        <img :src="project.StartImage" />
                                        <button type="button" class="btn btn-delete margin-top-15" @click="removeStartImage()"
                                                v-if="project.StartImage && !deleteStartImage ">
                                            Удалить изображение
                                        </button>
                                    </div>
                                    <div class="form-field">
                                        <div class="file-upload-zone">
                                            <input type="file" id="dropFilesStart" ref="dropFilesStart" name="dropFilesStart"
                                                   class="file-upload-zone-btn" accept=".jpg,.jpeg,.png,.gif,.bmp" />
                                            <label id="dropFilesBtnLblStart" for="dropFilesStart" class="file-upload-zone-lbl">
                                                Перетяните
                                                сюда изображение или нажмите, чтобы выбрать
                                            </label>
                                        </div>
                                        <div id="fileListStart" v-if="fileStart != null" class="fileList">
                                            Выбран файл: {{fileStart.name}}
                                        </div>

                                    </div>
                                </div>
                                <div class="line-separator margin-bottom-15 margin-top-15"></div>

                                <label class="input-text-lbl">Политика конфиденциальности сервиса:</label>
                                <div class="form-field margin-top-10 flex">
                                    <div class="form-field file-uploaded margin-right-20" v-if="project.PolicyFile && !deletePolicyFile">
                                        <a :href="project.PolicyFile" target="_blank">Политика сервиса</a>
                                        <button type="button" class="btn btn-delete margin-top-15" @click="deletePolicyFile = true"
                                                v-if="project.PolicyFile && !deletePolicyFile">
                                            Удалить файл
                                        </button>
                                    </div>
                                    <div class="form-field">
                                        <div class="file-upload-zone">
                                            <input type="file" id="dropFiles2" ref="dropFiles2" name="dropFiles2"
                                                   class="file-upload-zone-btn" accept=".pdf,.html" />
                                            <label for="dropFiles2" class="file-upload-zone-lbl">Перетяните сюда файл или нажмите, чтобы выбрать</label>
                                        </div>
                                        <div v-if="policyFile != null" class="fileList">
                                            Выбран файл: {{policyFile.name}}
                                        </div>
                                    </div>
                                </div>

                                <label class="input-text-lbl">Правила программы:</label>
                                <div class="form-field margin-top-10 flex">
                                    <div class="form-field file-uploaded margin-right-20" v-if="project.RulesFile && !deleteRulesFile">
                                        <a :href="project.RulesFile" target="_blank">Правила программы</a>
                                        <button type="button" class="btn btn-delete margin-top-15" @click="deleteRulesFile = true"
                                                v-if="project.RulesFile && !deleteRulesFile">
                                            Удалить файл
                                        </button>
                                    </div>
                                    <div class="form-field">
                                        <div class="file-upload-zone">
                                            <input type="file" id="dropFiles3" ref="dropFiles3" name="dropFiles3"
                                                   class="file-upload-zone-btn" accept=".pdf,.html" />
                                            <label for="dropFiles3" class="file-upload-zone-lbl">Перетяните сюда файл или нажмите, чтобы выбрать</label>
                                        </div>
                                        <div v-if="rulesFile != null" class="fileList">
                                            Выбран файл: {{rulesFile.name}}
                                        </div>
                                    </div>
                                </div>
                                <div class="line-separator margin-bottom-15 margin-top-15"></div>
                                <div class="form-field">
                                    <div class="form-field">
                                        <input id="RegisterSettings.AutoConfirmUser" name="RegisterSettings.AutoConfirmUser" value="true" type="checkbox" class="input-checkbox"
                                               v-model="project.RegisterSettings.AutoConfirmUser" />
                                        <label for="RegisterSettings.AutoConfirmUser" class="input-checkbox-lbl">Автоматическое подтверждение пользователя</label>
                                    </div>
                                    <div class="form-field">
                                        <input id="RegisterSettings.Enabled" name="RegisterSettings.Enabled" value="true" type="checkbox" class="input-checkbox"
                                               v-model="project.RegisterSettings.Enabled" />
                                        <label for="RegisterSettings.Enabled" class="input-checkbox-lbl">Разрешить самостоятельную регистрацию</label>
                                    </div>
                                    <div class="form-field" v-if="project.RegisterSettings.Enabled">
                                        <label class="input-text-lbl">Код для регистрации через мобильное приложение</label>
                                        <div class="flex">
                                            <div style="width:100%">
                                                <input type="text" class="input-text" name="RegisterCodeMobile" disabled="true" v-model="project.RegisterCodeMobile" />
                                            </div>
                                            <div style="width:110px;min-width:110px;margin-left:15px">
                                                <button type="button" class="btn" @click.stop="GetRegisterCodeMobile">Обновить код</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-field" v-if="project.RegisterSettings.Enabled">
                                        <label class="input-text-lbl">Роль по умолчанию</label>
                                        <drop-down :items="rolesOrdered"
                                                   :dataField="'Id'"
                                                   :textField="'Name'"
                                                   v-model="project.RegisterSettings.DefaultRoleId" class=""></drop-down>
                                    </div>
                                    <div class="form-field draggable-item" v-if="project.RegisterSettings.Enabled" style="cursor:default">
                                        <div class="form-field">
                                            <label class="input-text-lbl">
                                                Торговая точка
                                                <span class="required" aria-required="true">*</span>
                                            </label>
                                        </div>
                                        <div class="form-field-group">
                                            <div class="form-field">
                                                <input type="text" name="RegisterTradePointName" autocomplete="off"
                                                       v-model="project.RegisterSettings.RegisterTradePointName" v-validate="'required'"
                                                       :disabled="project.RegisterSettings.RegisterTradePointDisabled"
                                                       :class="['input-text', {'input-error': errors.has('RegisterTradePointName')}]" />
                                                <span class="field-validation-valid">{{ errors.first('RegisterTradePointName') }}</span>
                                            </div>
                                            <div class="form-field">
                                                <drop-down :items="[{Id: 0, Name:'Ввод текста'}, {Id: 1, Name:'Выбор из адрески'}]"
                                                       :dataField="'Id'"
                                                       :textField="'Name'"
                                                       :disabled="project.RegisterSettings.RegisterTradePointDisabled"
                                                       v-model="project.RegisterSettings.RegisterTradePointType" class=""></drop-down>
                                            </div>
                                        </div>
                                        <div class="form-field" v-if="project.RegisterSettings.RegisterTradePointType === RegisterTradePointTypes.Select">
                                            <div class="form-field-group">
                                                <div class="">
                                                    <input id="TradePointColumns2" name="TradePointColumns2" value="[Area]"
                                                           type="checkbox"
                                                           :class="['input-checkbox', {'input-error': errors.has('TradePointColumns2')}]"
                                                           v-validate="{ required: tradePointColumnsRequired }"
                                                           v-model="project.RegisterSettings.TradePointColumns"
                                                          :disabled="project.RegisterSettings.RegisterTradePointDisabled" />
                                                    <label for="TradePointColumns2" class="input-checkbox-lbl">Область</label>
                                                </div>
                                                <div class="margin-left-20">
                                                    <input id="TradePointColumns3" name="TradePointColumns3" value="[Region]"
                                                           type="checkbox"
                                                           :class="['input-checkbox', {'input-error': errors.has('TradePointColumns3')}]"
                                                           v-validate="{ required: tradePointColumnsRequired }"
                                                           v-model="project.RegisterSettings.TradePointColumns"
                                                          :disabled="project.RegisterSettings.RegisterTradePointDisabled" />
                                                    <label for="TradePointColumns3" class="input-checkbox-lbl">Регион</label>
                                                </div>
                                                <div class="margin-left-20">
                                                    <input id="TradePointColumns4" name="TradePointColumns4" value="[City]"
                                                           type="checkbox"
                                                           :class="['input-checkbox', {'input-error': errors.has('TradePointColumns4')}]"
                                                           v-validate="{ required: tradePointColumnsRequired }"
                                                           v-model="project.RegisterSettings.TradePointColumns" 
                                                          :disabled="project.RegisterSettings.RegisterTradePointDisabled"/>
                                                    <label for="TradePointColumns4" class="input-checkbox-lbl">Город</label>
                                                </div>
                                                <div class="margin-left-20">
                                                    <input id="TradePointColumns5" name="TradePointColumns5" value="[Address]"
                                                           type="checkbox"
                                                           :class="['input-checkbox', {'input-error': errors.has('TradePointColumns5')}]"
                                                           v-validate="{ required: tradePointColumnsRequired }"
                                                           v-model="project.RegisterSettings.TradePointColumns" 
                                                          :disabled="project.RegisterSettings.RegisterTradePointDisabled"/>
                                                    <label for="TradePointColumns5" class="input-checkbox-lbl">Адрес</label>
                                                </div>
                                                <div class="margin-left-20">
                                                    <input id="TradePointColumns1" name="TradePointColumns1" value="[Name]"
                                                           type="checkbox"
                                                           :class="['input-checkbox', {'input-error': errors.has('TradePointColumns1')}]"
                                                           v-validate="{ required: tradePointColumnsRequired }"
                                                           v-model="project.RegisterSettings.TradePointColumns"
                                                          :disabled="project.RegisterSettings.RegisterTradePointDisabled" />
                                                    <label for="TradePointColumns1" class="input-checkbox-lbl">Наименование</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-field margin-top-3">
                                            <input id="RegisterTradePointDisabled" name="RegisterTradePointDisabled" value="true"
                                                   type="checkbox" class="input-checkbox"
                                                   v-model="project.RegisterSettings.RegisterTradePointDisabled" />
                                            <label for="RegisterTradePointDisabled" class="input-checkbox-lbl" style="margin-top:0">Отключить поле</label>
                                        </div>
                                    </div>
                                    <div class="form-field" v-if="project.RegisterSettings.Enabled">
                                        <Container @drop="onRegFieldsDrop" :lock-axis="'y'">
                                            <Draggable v-for="(field, i) of regFieldsOrdered">
                                                <div class="draggable-item">
                                                    <div class="form-field-group mob-inline">
                                                        <div class="form-field">
                                                            <label class="input-text-lbl">
                                                                Название
                                                                <span class="required" aria-required="true">*</span>
                                                            </label>
                                                            <input type="text" class="input-text" placeholder="Название" maxlength="245"
                                                                   :name="'fieldName' + i"
                                                                   v-model="field.FieldName"
                                                                   v-validate="'required'"
                                                                   :class="['input-text', {'input-error': errors.has('fieldName' + i)}]"
                                                                   data-vv-as="Название" />
                                                            <span class="field-validation-valid">{{ errors.first('fieldName' + i) }}</span>
                                                        </div>
                                                        <div class="form-field">
                                                            <label class="input-text-lbl">
                                                                Тип поля
                                                            </label>
                                                            <drop-down :items="[{Id: 'text', Name:'Ввод текста'}, {Id: 'select', Name:'Список'}]"
                                                                       :dataField="'Id'"
                                                                       :textField="'Name'"
                                                                       v-model="field.FieldType"></drop-down>
                                                        </div>

                                                        <div class="form-field" style="width:35px;min-width:35px;padding-top:23px" v-if="project.new || field.new || field.CanDelete">
                                                            <button type="button" class="btn btn-default btn-img" @click.stop="onRemoveRegField(i)">
                                                                <img src="../../../img/icon-del.png" alt="" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="form-field" v-if="field.FieldType === 'select'">
                                                        <label class="input-text-lbl">
                                                            Массив вариантов выпадающего списка в формате ["Вариант-1", "Вариант-2"]<br>
                                                            <span class="test-wrong">Двойные кавычки используются только для обозначения границ слова</span>
                                                        </label>
                                                        <input type="text" :name="'fieldNameSelect' + i"
                                                               :class="['input-text', {'input-error': errors.has('fieldNameSelect' + i)}]"
                                                               placeholder='Массив вариантов через запятую, напр.: ["Вариант-1", "Вариант-2"]'
                                                               v-model="field.Options"
                                                               v-validate="{required: true, jsonArray: true}"
                                                               data-vv-as="Массив" />
                                                        <span class="field-validation-valid">{{ errors.first('fieldNameSelect' + i) }}</span>
                                                    </div>
                                                    <div class="form-field margin-top-3">
                                                        <input :id="'fieldDeleted' + i" :name="'fieldDeleted' + i" value="true"
                                                               type="checkbox" class="input-checkbox"
                                                               v-model="field.Deleted" />
                                                        <label :for="'fieldDeleted' + i" class="input-checkbox-lbl" style="margin-top:0">Отключить поле</label>
                                                    </div>
                                                </div>
                                            </Draggable>
                                        </Container>

                                        <button type="button" class="btn btn-primary margin-top-15 btn-img" @click="addRegField()">
                                            <img src="../../../img/icon-plus-2.png" alt="" />
                                        </button>
                                    </div>
                                </div>
                                <div class="line-separator margin-bottom-15 margin-top-15"></div>
                                <div class="form-field">
                                    <input id="ExternalEnabled" value="false" type="checkbox" class="input-checkbox"
                                           v-model="project.ExternalEnabled" />
                                    <label for="ExternalEnabled" class="input-checkbox-lbl">Разрешить авторизацию через соц. сети</label>
                                </div>
                                <div class="form-field-group" v-if="project.ExternalEnabled">
                                    <div class="form-field form-field-auto">
                                        <input id="ExternalVk" value="false" type="checkbox" class="input-checkbox"
                                               v-model="project.ExternalVk" />
                                        <label for="ExternalVk" class="input-checkbox-lbl">Vk</label>
                                    </div>
                                    <div class="form-field form-field-auto">
                                        <input id="ExternalGoogle" value="false" type="checkbox" class="input-checkbox"
                                               v-model="project.ExternalGoogle" />
                                        <label for="ExternalGoogle" class="input-checkbox-lbl">Google</label>
                                    </div>
                                    <!--div class="form-field form-field-auto">
        <input id="ExternalFacebook" value="false" type="checkbox" class="input-checkbox"
               v-model="project.ExternalFacebook" />
        <label for="ExternalFacebook" class="input-checkbox-lbl">Facebook (требуется https соединение)</label>
        </div-->
                                </div>
                            </div>
                        </div>

                        <div class="block-in-page closed">
                            <h2 class="margin-bottom-20 block-in-page-collapce">Названия разделов</h2>
                            <div class="block-in-page-detail">
                                <div class="draggable-item no-drag" @dblclick="onPageEdit(reportAddPage)" v-if="reportAddPage">
                                    <template v-if="reportAddPage.Edited">
                                        <div class="form-field flex">
                                            <label class="input-text-lbl" style="padding-top:8px;margin-right:20px">{{reportAddPage.DefaultName}}</label>
                                            <input type="text" class="input-text"
                                                   v-model="reportAddPage.Name"
                                                   @click.stop="" />
                                        </div>
                                    </template>
                                    <template v-if="!reportAddPage.Edited">
                                        {{reportAddPage.DefaultName}} - {{ reportAddPage.Name }}
                                        <div class="btns flex" style="float:right;margin-top:-6px">
                                            <button type="button" class="btn btn-default btn-img" @click.stop="onPageEdit(reportAddPage)">
                                                <img src="../../../img/pencil-edit-button.png" alt="" />
                                            </button>
                                        </div>
                                    </template>
                                </div>

                                <Container @drop="onDrop" :lock-axis="'y'">
                                    <Draggable v-for="(page, i) of pagesOrdered" :lock-axis="'x'">
                                        <div class="draggable-item" @dblclick="onPageEdit(page)">
                                            <template v-if="page.Edited">
                                                <div class="form-field flex">
                                                    <label class="input-text-lbl" style="padding-top:8px;margin-right:20px">{{page.DefaultName}}</label>
                                                    <input type="text" class="input-text"
                                                           v-model="page.Name"
                                                           @mousedown.stop=""
                                                           @click.stop="" />
                                                </div>
                                            </template>
                                            <template v-if="!page.Edited">
                                                {{page.DefaultName}} - {{ page.Name }}
                                                <div class="btns flex" style="float:right;margin-top:-6px">
                                                    <button type="button" class="btn btn-default btn-img" @click.stop="onPageEdit(page)">
                                                        <img src="../../../img/pencil-edit-button.png" alt="" />
                                                    </button>
                                                </div>
                                            </template>
                                        </div>
                                    </Draggable>
                                </Container>
                            </div>
                        </div>

                        <div class="block-in-page closed">
                            <h2 class="margin-bottom-20 block-in-page-collapce">Настройка отчета</h2>
                            <div class="block-in-page-detail">
                                <div class="form-field-group">
                                    <div class="form-field" style="">
                                        <drop-down :items="[{Id: 0, Name:'Выключить отчеты'},{Id: 1, Name:'Ручной режим внесения данных'},{Id: 2, Name:'Загрузка через QR код'}]"
                                                   :dataField="'Id'"
                                                   :textField="'Name'"
                                                   v-model="project.ReportType" class=""></drop-down>
                                    </div>
                                </div>
                                <template v-if="project.ReportType === 1">
                                    <div class="form-field-group">
                                        <div class="form-field" style="width: 30%;">
                                            <input id="ReportExcelEnabled" name="ReportExcelEnabled" value="true"
                                                   type="checkbox" class="input-checkbox"
                                                   v-model="project.ReportExcelEnabled" />
                                            <label for="ReportExcelEnabled" class="input-checkbox-lbl">Разрешить импорт из Excel</label>
                                        </div>
                                    </div>
                                    <div class="line-separator margin-bottom-15 margin-top-15"></div>
                                    <div class="form-field-group">
                                        <div class="form-field" style="width: 30%;">
                                            <input id="ReportOnlyOneItemAllowed" name="ReportOnlyOneItemAllowed" value="true"
                                                   type="checkbox" class="input-checkbox"
                                                   v-model="project.ReportOnlyOneItemAllowed" />
                                            <label for="ReportOnlyOneItemAllowed" class="input-checkbox-lbl">Можно добавить только одну запись в таблицу</label>
                                        </div>
                                    </div>
                                    <div class="line-separator margin-bottom-15 margin-top-15"></div>
                                    <div class="form-field-group">
                                        <div class="form-field" style="width: 250px; min-width:250px">
                                            <input id="ReportDateRequired" name="ReportDateRequired" value="true"
                                                   type="checkbox" class="input-checkbox"
                                                   v-model="project.ReportDateRequired" />
                                            <label for="ReportDateRequired" class="input-checkbox-lbl">Указывать дату отчета</label>
                                        </div>
                                        <template v-if="project.ReportDateRequired">
                                            <div class="form-field">
                                                <label class="input-text-lbl">
                                                    Название поля в отчете
                                                </label>
                                                <input type="text" class="input-text"
                                                       name="ReportDateCaption"
                                                       v-model="project.ReportDateCaption"
                                                       v-validate="'required'"
                                                       :class="['input-text', {'input-error': errors.has('ReportDateCaption')}]" />
                                                <span class="field-validation-valid"></span>
                                            </div>
                                            <div class="form-field">
                                                <input id="ReportDateDefault" name="ReportDateDefault" value="true"
                                                       type="checkbox" class="input-checkbox"
                                                       v-model="project.ReportDateDefault" />
                                                <label for="ReportDateDefault" class="input-checkbox-lbl">По умолчанию "сегодня"</label>
                                            </div>
                                        </template>
                                    </div>

                                    <div class="line-separator margin-bottom-15 margin-top-15"></div>

                                    <Container @drop="onReportSettingsDrop" :lock-axis="'y'">
                                        <Draggable v-for="(settings, i) of reportSettingsOrdered">
                                            <div class="draggable-item">
                                                <div class="form-field-group">
                                                    <div class="form-field" v-if="settings.type !== 'sku'">
                                                        <label class="input-text-lbl">
                                                            Название поля в БД
                                                        </label>
                                                        <input type="text" class="input-text" placeholder="Поле в базе данных"
                                                               :name="'settingsName' + i"
                                                               v-model="settings.name"
                                                               :disabled="!project.new && !settings.new"
                                                               v-validate="'required'"
                                                               :class="['input-text', {'input-error': errors.has('settingsName' + i)}]"
                                                               @change="onReportSettingsCaptionChange(settings)" />
                                                        <span class="field-validation-valid"></span>
                                                    </div>
                                                    <div class="form-field">
                                                        <label class="input-text-lbl">
                                                            Название поля в отчете
                                                        </label>
                                                        <input type="text" class="input-text" placeholder="Заголовок"
                                                               :name="'settingsCaption' + i"
                                                               v-model="settings.caption"
                                                               v-validate="'required'"
                                                               :class="['input-text', {'input-error': errors.has('settingsCaption' + i)}]"
                                                               @change="onReportSettingsCaptionChange(settings)" />
                                                        <span class="field-validation-valid"></span>
                                                    </div>
                                                    <div class="form-field" style="width:200px;min-width:200px">
                                                        <label class="input-text-lbl">
                                                            Тип поля
                                                        </label>
                                                        <drop-down :items="reportSettingsTypes"
                                                                   :dataField="'Id'"
                                                                   :textField="'Name'"
                                                                   v-model="settings.type"
                                                                   @change="onReportSettingsTypesChange(settings)"></drop-down>
                                                    </div>
                                                    <div class="form-field" style="">
                                                        <label class="input-text-lbl">
                                                            Описание
                                                        </label>
                                                        <textarea style="height:50px" rows="10"
                                                                  :name="'SettingsDescription' + i"
                                                                  :class="['input-memo', {'input-error': errors.has('SettingsDescription' + i)}]"
                                                                  v-model="settings.description"
                                                                  data-vv-as="Описание"></textarea>
                                                    </div>
                                                    <div class="form-field" v-if="settings.type === 'sku'" style="width:200px;min-width:200px;padding-top:23px">
                                                        <button type="button" class="btn" @click.stop="setUpSkuList(settings)">Настроить выбор</button>
                                                    </div>
                                                    <div class="form-field" v-if="settings.type === 'sku'">
                                                        <label class="input-text-lbl">
                                                            Название подсказки при выборе
                                                        </label>
                                                        <input type="text" class="input-text" placeholder="По умолчанию - Выберите sku"
                                                               :name="'settingsPlaceholder' + i"
                                                               v-model="settings.placeholder"
                                                               :class="['input-text', {'input-error': errors.has('settingsPlaceholder' + i)}]" />
                                                    </div>
                                                    <div class="form-field" style="width:35px;min-width:35px;padding-top:23px"
                                                         v-if="project.new || settings.new">
                                                        <button type="button" class="btn btn-default btn-img"
                                                                @click.stop="onRemoveReportSettings(settings, i)">
                                                            <img src="../../../img/icon-del.png" alt="" />
                                                        </button>
                                                    </div>
                                                    <div class="form-field" style="width:110px;min-width:110px" v-if="!project.new && !settings.new">
                                                        <input :id="'settingsDeleted' + i" :name="'settingsDeleted' + i" value="true"
                                                               type="checkbox" class="input-checkbox"
                                                               v-model="settings.deleted"
                                                               :disabled="getDisabledStatus(settings)"
                                                               @change="onSettingsDeletedChange(settings)" />
                                                        <label :for="'settingsDeleted' + i" class="input-checkbox-lbl" @click.stop="onSettingsDeletedClick('settingsDeleted' + i, settings)">Неактивно</label>
                                                    </div>
                                                </div>
                                                <div class="form-field"
                                                     v-if="settings.type === 'select' && settings.name !== 'EquipmentType'">
                                                    <label class="input-text-lbl">
                                                        Массив вариантов выпадающего списка в формате ["Вариант-1", "Вариант-2"]<br>
                                                        <span class="test-wrong">Лишние кавычки не допускаются!</span>
                                                    </label>
                                                    <input type="text" :name="'settingsSelectArray' + i"
                                                           :class="['input-text', {'input-error': errors.has('settingsSelectArray' + i)}]"
                                                           placeholder='Массив вариантов через запятую, напр.: ["Вариант-1", "Вариант-2"]'
                                                           v-model="settings.options"
                                                           v-validate="{required: true, jsonArray: true}"
                                                           data-vv-as="Массив" />
                                                    <span class="field-validation-valid">{{ errors.first('settingsSelectArray' + i) }}</span>
                                                </div>

                                                <div class="form-field">
                                                    <template v-if="settings.type === 'int' || settings.type === 'decimal'">
                                                        <input :id="'showInReportList' + i" :name="'showInReportList' + i" value="true"
                                                               type="checkbox" class="input-checkbox"
                                                               v-model="settings.showInReportList" />
                                                        <label :for="'showInReportList' + i" class="input-checkbox-lbl">
                                                            Показывать в
                                                            списке
                                                        </label>

                                                        <input :id="'sumUp' + i" :name="'sumUp' + i" value="true" type="checkbox"
                                                               class="input-checkbox"
                                                               v-model="settings.sumUp" />
                                                        <label :for="'sumUp' + i" class="input-checkbox-lbl">Суммировать</label>
                                                    </template>
                                                </div>
                                            </div>
                                        </Draggable>
                                    </Container>
                                    <button type="button" class="btn btn-primary margin-top-15 btn-img" @click="addReportSettings()">
                                        <img src="../../../img/icon-plus-2.png" alt="" />
                                    </button>
                                </template>
                            </div>
                        </div>

                        <div class="block-in-page closed">
                            <h2 class="margin-bottom-20 block-in-page-collapce">Настройка начисления баллов за отчеты</h2>
                            <div class="block-in-page-detail">
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Частота загрузки отчётов по торговой точке
                                    </label>
                                    <drop-down v-if="dataLoadingFrequencies.length > 0"
                                               :items="dataLoadingFrequencies"
                                               :dataField="'Id'"
                                               :textField="'Name'"
                                               v-model="project.DataLoadingFrequency"></drop-down>
                                </div>

                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Период активации баллов
                                    </label>
                                    <drop-down :items="activationPeriodTypes"
                                               :dataField="'Id'"
                                               :textField="'Name'"
                                               v-model="project.bonusSettings.activationPeriod.type"></drop-down>
                                </div>

                                <template v-if="project.bonusSettings.activationPeriod.type === 'sum' ||
                                          project.bonusSettings.activationPeriod.type === 'fact'">
                                    <div class="form-field" v-if="project.bonusSettings.activationPeriod.type === 'sum'">
                                        <label class="input-text-lbl">
                                            Суммарно за период
                                        </label>
                                        <drop-down :items="activationPeriods"
                                                   :dataField="'Id'"
                                                   :textField="'Name'"
                                                   v-model="project.bonusSettings.activationPeriod.data.period"></drop-down>
                                    </div>
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Баллы станут доступны для использования через (дней)
                                        </label>
                                        <input v-model="project.bonusSettings.activationPeriod.data.value" type="text" class="input-text" placeholder="Введите количество дней" />
                                    </div>
                                    <div class="form-field" v-if="project.ReportDateRequired">
                                        <label class="input-text-lbl">
                                            От какой даты начинается отсчет дней:
                                        </label>
                                        <drop-down :items="activationFromDate"
                                                   :dataField="'Id'"
                                                   :textField="'Name'"
                                                   v-model="project.bonusSettings.activationPeriod.data.fromDate"></drop-down>
                                    </div>
                                </template>
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Период действия баллов
                                    </label>
                                    <drop-down :items="durationPeriods"
                                               :dataField="'Id'"
                                               :textField="'Name'"
                                               v-model="project.bonusSettings.durationPeriod"></drop-down>
                                </div>
                                <div class="line-separator"></div>

                                <p class="caption-help">Баллы, начисляемые за отчеты</p>
                                <div class="form-field margin-top-5">
                                    <label class="input-text-lbl">
                                        Принцип начисления
                                    </label>
                                    <drop-down :items="bonusStrategies"
                                               :dataField="'Id'"
                                               :textField="'Name'"
                                               v-model="project.bonusSettings.bonusStrategy.type"></drop-down>
                                </div>
                                <template v-if="project.bonusSettings.bonusStrategy.type === 'fact'">
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Количество баллов
                                        </label>
                                        <touch-spin v-model="project.bonusSettings.bonusStrategy.data.value" name="bonusStrategyValue"
                                                    :min="0" :decimals="2" :step="0.01"
                                                    v-validate="'required'"
                                                    :class="['input-text', {'input-error': errors.has('bonusStrategyValue')}]"></touch-spin>
                                    </div>
                                </template>

                                <template v-if="project.bonusSettings.bonusStrategy.type === 'data'">
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Выберите поле отчета, на основании которого начислять баллы
                                        </label>
                                        <drop-down :items="bonusStrategyFields"
                                                   :dataField="'Id'"
                                                   :textField="'Name'"
                                                   v-model="project.bonusSettings.bonusStrategy.data.fieldName"></drop-down>
                                    </div>
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Принцип начисления
                                        </label>
                                        <drop-down :items="bonusStrategyAccrualTypes"
                                                   :dataField="'Id'"
                                                   :textField="'Name'"
                                                   v-model="project.bonusSettings.bonusStrategy.data.accrualType"></drop-down>

                                        <i v-if="project.bonusSettings.bonusStrategy.data.accrualType == 1">
                                            по факту принятия отчета берется сумма по Полю и умножается на %
                                        </i>
                                        <i v-if="project.bonusSettings.bonusStrategy.data.accrualType == 2">
                                            по факту принятия отчета берется сумма по Полю и умножается на Значение
                                        </i>
                                    </div>
                                    <div class="form-field" v-if="project.bonusSettings.bonusStrategy.data.accrualType == 1">
                                        <label class="input-text-lbl">
                                            Выберите дату для определения ставки процента
                                        </label>
                                        <drop-down :items="bonusStrategyAccrualValueDate"
                                                   :dataField="'Value'"
                                                   :textField="'Name'"
                                                   v-model="project.bonusSettings.bonusStrategy.data.accrualValueDate"></drop-down>
                                    </div>
                                    <div class="report-block-items margin-bottom-20"
                                         v-if="project.bonusSettings.bonusStrategy.data.accrualType == 1 && project.bonusSettings.bonusStrategy.data.accrualValueDate !== 'none'">
                                        <report-items-table ref="reportItems" class="report-items"
                                                            v-model="project.bonusSettings.bonusStrategy.data.ValueItems"
                                                            :bonusSettings="accrualValueTable.bonusSettings"
                                                            :tradePoint="accrualValueTable.TradePoint"
                                                            :reportSettings="accrualValueTable.reportSettings"
                                                            :equipmentTypes="accrualValueTable.equipmentTypes"
                                                            :sku="accrualValueTable.sku"
                                                            :canBeEdited="accrualValueTable.canBeEdited"
                                                            :minItems="accrualValueTable.minItems"
                                                            :maxItems="accrualValueTable.maxItems"></report-items-table>
                                    </div>
                                    <div class="form-field" v-else>
                                        <label class="input-text-lbl">
                                            Значение
                                        </label>
                                        <touch-spin v-model="project.bonusSettings.bonusStrategy.data.value" name="bonusStrategyValue"
                                                    :min="0" :decimals="2" :step="0.01"
                                                    v-validate="'required'"
                                                    :class="['input-text', {'input-error': errors.has('bonusStrategyValue')}]"></touch-spin>
                                        <!--                                        <input type="text" class="input-text" placeholder="Введите значение" name="bonusStrategyValue"-->
                                        <!--                                               v-model="project.bonusSettings.bonusStrategy.data.value"-->
                                        <!--                                               v-validate="'required'"-->
                                        <!--                                               :class="['input-text', {'input-error': errors.has('bonusStrategyValue')}]" />-->
                                    </div>

                                </template>

                                <template v-if="project.bonusSettings.bonusStrategy.type === 'sp'">
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Выберите процедуру из базы данных
                                        </label>
                                        <drop-down :items="bonusStrategyProcedures"
                                                   :dataField="'Id'"
                                                   :textField="'Name'"
                                                   v-model="project.bonusSettings.bonusStrategy.data.value"></drop-down>
                                    </div>
                                </template>
                                <template v-if="project.bonusSettings.bonusStrategy.type === 'sku'">
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Выберите поле Sku на основании которого начисляются баллы
                                        </label>
                                        <drop-down :items="bonusStrategySkuFields"
                                                   :dataField="'Id'"
                                                   :textField="'Name'"
                                                   v-model="project.bonusSettings.bonusStrategy.data.fieldName"></drop-down>
                                    </div>
                                    <div class="form-field margin-top-20">
                                        <label class="input-text-lbl">
                                            <strong>Тип бонуса</strong>
                                        </label>
                                        <drop-down :items="[{Id: 'fixed', Name: 'Фиксированный за единицу'}, {Id: 'percent', Name: 'Процент от суммы'}]"
                                                   :dataField="'Id'"
                                                   :textField="'Name'"
                                                   v-model="project.bonusSettings.bonusStrategy.data.bonusType"></drop-down>
                                    </div>
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Выберите поле Sku - {{project.bonusSettings.bonusStrategy.data.bonusType === 'fixed' ? 'количество' : 'сумма продажи'}}
                                        </label>
                                        <drop-down name="BonusStrategyFields"
                                                   :items="bonusStrategyFields"
                                                   :dataField="'Id'"
                                                   :textField="'Name'"
                                                   withSelectItem="true"
                                                   v-validate="'required'"
                                                   v-model="project.bonusSettings.bonusStrategy.data.countFieldName"
                                                   :class="[{'input-error': errors.has('BonusStrategyFields')}]"></drop-down>
                                    </div>

                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Настройте стоимость внутри каждого SKU
                                        </label>
                                    </div>

                                    <div class="form-field margin-top-20">
                                        <label class="input-text-lbl">
                                            <strong>Дата отчета для выбора баллов за SKU</strong>
                                        </label>
                                        <drop-down :items="[{Id: 'report', Name: 'Дата заполнения отчёта'}, {Id: 'selldate', Name: 'Дата «продажи»'}]"
                                                   :dataField="'Id'"
                                                   :textField="'Name'"
                                                   withSelectItem="false"
                                                   v-model="project.bonusSettings.bonusStrategy.data.reportDateType"></drop-down>
                                    </div>
                                    <div class="form-field margin-top-20">
                                        <label class="input-text-lbl">
                                            <strong>Период начисления баллов</strong>
                                        </label>
                                        <drop-down :items="[{Id: 'default', Name: 'По умолчанию'}, {Id: 'report', Name: 'По дате отчёта'}, {Id: 'selldate', Name: 'По дате «продажи»'}]"
                                                   :dataField="'Id'"
                                                   :textField="'Name'"
                                                   withSelectItem="false"
                                                   v-model="project.bonusSettings.bonusStrategy.data.reportPeriodType"></drop-down>
                                    </div>

                                    <div class="form-field" v-if="project.bonusSettings.bonusStrategy.data.reportDateType === 'selldate' || project.bonusSettings.bonusStrategy.data.reportPeriodType === 'selldate'">
                                        <label class="input-text-lbl">
                                            Выберите поле даты «продажи»
                                        </label>
                                        <drop-down name="BonusStrategyDateFields"
                                                   :items="bonusStrategyDateFields"
                                                   :dataField="'Id'"
                                                   :textField="'Name'"
                                                   v-validate="'required'"
                                                   v-model="project.bonusSettings.bonusStrategy.data.reportSellDateFieldName"
                                                   :class="[{'input-error': errors.has('BonusStrategyDateFields')}]"></drop-down>
                                    </div>

                                    <div class="form-field margin-top-20">
                                        <label class="input-text-lbl">
                                            <strong>Выбор детализации</strong>
                                        </label>
                                        <drop-down :items="[{Id: 'sum', Name: 'Суммарно за отчет'}, {Id: 'sku', Name: 'По SKU'}]"
                                                   :dataField="'Id'"
                                                   :textField="'Name'"
                                                   withSelectItem="false"
                                                   v-model="project.bonusSettings.bonusStrategy.data.reportDetalizationType"></drop-down>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <div class="block-in-page closed">
                            <h2 class="margin-bottom-20 block-in-page-collapce">Настройка блока фотографий</h2>
                            <div class="block-in-page-detail">
                                <div class="form-field-group" v-for="(item, i) of project.ReportPhotoFields">
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Заголовок блока
                                        </label>
                                        <input type="text" class="input-text" placeholder="Заголовок блока"
                                               :name="'photoSettingsName' + i"
                                               v-model="item.Name"
                                               v-validate="'required'"
                                               :class="[{'input-error': errors.has('photoSettingsName' + i)}]" />
                                        <span class="field-validation-valid"></span>
                                    </div>
                                    <div class="form-field">
                                        <input :id="'photoSettingsRequired' + i" :name="'photoSettingsRequired' + i"
                                               value="true" type="checkbox" class="input-checkbox"
                                               v-model="item.Required" />
                                        <label :for="'photoSettingsRequired' + i"
                                               class="input-checkbox-lbl">Обязательно</label>
                                    </div>
                                    <div class="form-field" style="">
                                        <input :id="'PdfAndExcelFilesEnabled' + i" :name="'PdfAndExcelFilesEnabled' + i" value="true"
                                               type="checkbox" class="input-checkbox"
                                               v-model="item.PdfAndExcelFilesEnabled" />
                                        <label :for="'PdfAndExcelFilesEnabled' + i" class="input-checkbox-lbl">Разрешить прикреплять файлы в формате PDF, Excel</label>
                                    </div>
                                    <div class="form-field" style="width:35px;min-width:35px;padding-top:23px">
                                        <button type="button" class="btn btn-default btn-img"
                                                @click.stop="onRemovePhotoSettings(i)">
                                            <img src="../../../img/icon-del.png" alt="" />
                                        </button>
                                    </div>
                                </div>

                                <div class="line-separator margin-bottom-15 margin-top-15"></div>

                                <button type="button" class="btn btn-primary margin-top-15 btn-img" @click="addPhotoSettings()">
                                    <img src="../../../img/icon-plus-2.png" alt="" />
                                </button>
                            </div>
                        </div>

                        <div class="block-in-page closed">
                            <h2 class="margin-bottom-20 block-in-page-collapce">Первый вход участника</h2>
                            <div class="block-in-page-detail">
                                <template class="form-field-group" v-for="(launchSettings, i) in project.ProjectFirstLaunchSettings">
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Действие {{ i + 1}}
                                        </label>
                                        <drop-down :items="[{Id: 1, Name: 'Показать всплывающее окно'}]"
                                                   :dataField="'Id'"
                                                   :textField="'Name'"
                                                   v-model="launchSettings.actionTypeId"></drop-down>
                                        <span class="field-validation-valid"></span>
                                    </div>
                                    <template v-if="launchSettings.actionTypeId === 1">
                                        <div class="form-field">
                                            <label class="input-text-lbl">
                                                Заголовок окна
                                            </label>
                                            <input type="text" class="input-text"
                                                   :name="'launchSettingsTitle' + i"
                                                   v-model="launchSettings.Title"
                                                   v-validate="'required'"
                                                   :class="[{'input-error': errors.has('launchSettingsTitle' + i)}]" />
                                            <span class="field-validation-valid"></span>
                                        </div>
                                        <div class="form-field margin-top-10 flex">
                                            <div class="form-field file-uploaded margin-right-20" v-if="launchSettings.FileName && !launchSettings.deleteImage">
                                                <a :href="launchSettings.FileName" download="launchSettings.FileTitle">{{launchSettings.FileTitle}}</a>
                                                <button type="button" class="btn btn-delete margin-top-15" @click="removeLaunchSettingsImage(launchSettings, i)"
                                                        v-if="launchSettings.FileName && !launchSettings.deleteImage">
                                                    Удалить файл
                                                </button>
                                            </div>
                                            <div class="form-field">
                                                <div class="file-upload-zone">
                                                    <input type="file" class="file-upload-zone-btn" accept=".pdf"
                                                           :id="'launchSettingsDropFiles' + i"
                                                           :ref="'launchSettingsDropFiles' + i"
                                                           :name="'launchSettingsDropFiles' + i"
                                                           @change="onLaunchSettingsImageChange($event, i)" />
                                                    <label :for="'launchSettingsDropFiles' + i" class="file-upload-zone-lbl">
                                                        Перетяните
                                                        сюда файл или нажмите, чтобы выбрать
                                                    </label>
                                                </div>
                                                <div v-if="launchSettings.file != null" class="fileList">
                                                    Выбран файл: {{launchSettings.file.name}}
                                                </div>

                                            </div>
                                        </div>
                                        <div class="form-field">
                                            <input :id="'ReadRequired' + i" :name="'ReadRequired' + i" value="true" type="checkbox" class="input-checkbox"
                                                   v-model="launchSettings.ReadRequired" />
                                            <label :for="'ReadRequired' + i" class="input-checkbox-lbl">Подтвердить прочтение</label>
                                        </div>

                                    </template>
                                    <div class="form-field" style="">
                                        <button type="button" class="btn btn-delete" @click.stop="onRemoveFirstLaunchSettings(i)">
                                            Удалить действие
                                        </button>
                                    </div>
                                    <div class="line-separator margin-bottom-20 margin-top-20"></div>
                                </template>
                                <button type="button" class="btn btn-primary margin-top-15 btn-img"
                                        @click="addFirstLaunchSettingsItem()">
                                    <img src="../../../img/icon-plus-2.png" alt="" />
                                </button>
                                <div class="margin-top-20">
                                    <div class="form-field">
                                        <input id="ComplimentarySettings.Enabled" name="ComplimentarySettings.Enabled" value="true" type="checkbox" class="input-checkbox"
                                               v-model="project.ComplimentarySettings.Enabled" />
                                        <label for="ComplimentarySettings.Enabled" class="input-checkbox-lbl">Баллы за активацию</label>
                                    </div>
                                    <template v-if="project.ComplimentarySettings.Enabled">
                                        <div class="form-field-group">
                                            <div class="form-field">
                                                <label class="input-text-lbl">
                                                    Начало периода активации
                                                    <span class="required" aria-required="true">*</span>
                                                </label>
                                                <div class="input-date-lbl">
                                                    <input-date name="PeriodStartDateFormatted"
                                                                v-validate="'required'"
                                                                v-model="project.ComplimentarySettings.PeriodStartDateFormatted"
                                                                @input="onChangeDate(project.ComplimentarySettings, 'PeriodStartDateFormatted', 'PeriodStartDate')"
                                                                :class="['input-text', {'input-error': errors.has('PeriodStartDateFormatted')}]"></input-date>
                                                </div>
                                            </div>
                                            <div class="form-field">
                                                <label class="input-text-lbl">
                                                    Окончание периода активации
                                                    <span class="required" aria-required="true">*</span>
                                                </label>
                                                <div class="input-date-lbl">
                                                    <input-date name="PeriodEndDateFormatted"
                                                                v-validate="'required'"
                                                                v-model="project.ComplimentarySettings.PeriodEndDateFormatted"
                                                                @input="onChangeDate(project.ComplimentarySettings, 'PeriodEndDateFormatted', 'PeriodEndDate')"
                                                                :class="['input-text', {'input-error': errors.has('PeriodEndDateFormatted')}]"></input-date>
                                                </div>
                                            </div>
                                            <div class="form-field">
                                                <label class="input-text-lbl">
                                                    Дата сгорания балов
                                                </label>
                                                <div class="input-date-lbl">
                                                    <input-date name="ExpirationDateFormatted"
                                                                v-model="project.ComplimentarySettings.ExpirationDateFormatted"
                                                                @input="onChangeDate(project.ComplimentarySettings, 'ExpirationDateFormatted', 'ExpirationDate')"
                                                                :class="['input-text', {'input-error': errors.has('ExpirationDateFormatted')}]"></input-date>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-field-group">
                                            <div class="form-field" style="width: calc(33% - 10px);">
                                                <label class="input-text-lbl">
                                                    Количество баллов
                                                </label>
                                                <touch-spin v-model="project.ComplimentarySettings.Amount" name="ComplimentarySettings.Amount"
                                                            :min="0" :decimals="2" :step="1"
                                                            v-validate="'required'"
                                                            :class="['input-text', {'input-error': errors.has('ComplimentarySettings.Amount')}]"></touch-spin>
                                            </div>
                                        </div>
                                    </template>
                                </div>

                            </div>
                        </div>

                        <div class="block-in-page closed">
                            <h2 class="margin-bottom-20 block-in-page-collapce">Аналитические отчеты</h2>
                            <div class="block-in-page-detail">
                                <div class="form-field" style="width: 30%;">
                                    <input id="AnalyticsReportEnabled" name="AnalyticsReportEnabled" value="true"
                                           type="checkbox" class="input-checkbox"
                                           v-model="project.AnalyticsReportEnabled" />
                                    <label for="AnalyticsReportEnabled" class="input-checkbox-lbl">Кнопка Отчет на стр. Аналитика</label>
                                </div>

                                <template v-if="project.AnalyticsReportEnabled">
                                    <div class="form-field">
                                        <drop-down :items="[{Value:0, Name: 'Выгружать данные графика в Excel'}, {Value:1, Name: 'Свой отчет'}]"
                                                   :dataField="'Value'"
                                                   :textField="'Name'"
                                                   v-model="project.AnalyticsReportProcedureType"></drop-down>
                                    </div>

                                    <div class="form-field" v-if="project.AnalyticsReportProcedureType === 1">
                                        <label class="input-text-lbl">Название процедуры</label>
                                        <input type="text" name="AnalyticsReportProcedureName"
                                               :class="['input-text', {'input-error': errors.has('AnalyticsReportProcedureName')}]"
                                               v-model="project.AnalyticsReportProcedureName"
                                               v-validate="{ rules: { required: project.AnalyticsReportProcedureType === 1 } }" />
                                    </div>

                                </template>

                                <div class="line-separator margin-bottom-15 margin-top-15"></div>
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Единица измерения вознаграждения
                                    </label>
                                    <drop-down :items="[{Id: 1, Name: 'Баллы'},{Id: 2, Name: 'Купоны'}]"
                                               :dataField="'Id'"
                                               :textField="'Name'"
                                               v-model="project.RewardUnitTypeId"></drop-down>
                                </div>
                                <!--<div class="form-field flex">
                <div class="form-field">
                    <input id="AnalyticsSwitchEnabled" name="AnalyticsSwitchEnabled" value="true" type="checkbox" class="input-checkbox"
                           v-model="project.AnalyticsSwitchEnabled" />
                    <label for="AnalyticsSwitchEnabled" class="input-checkbox-lbl">Показывать переключатель руб./шт.</label>
                </div>
            </div>-->
                                <div class="form-field-group">
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Цвет колонок на графике
                                        </label>
                                        <input name="AnalyticsColumnsColor" placeholder="Например, #FFFFFF"
                                               v-model="project.AnalyticsColumnsColor"
                                               :class="['input-text', {'input-error': errors.has('AnalyticsColumnsColor')}]" type="text">
                                        <span class="field-validation-valid">{{ errors.first('AnalyticsColumnsColor') }}</span>
                                    </div>
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Цвет рамки колонок на графике
                                        </label>
                                        <input name="AnalyticsBorderColor" placeholder="Например, #FFFFFF"
                                               v-model="project.AnalyticsBorderColor"
                                               :class="['input-text', {'input-error': errors.has('AnalyticsBorderColor')}]" type="text">
                                        <span class="field-validation-valid">{{ errors.first('AnalyticsBorderColor') }}</span>
                                    </div>
                                </div>

                                <div class="line-separator margin-bottom-15 margin-top-15"></div>

                                <h2>Настройки по ролям:</h2>
                                <div class="form-field-group margin-bottom-10" v-for="(roleSettings, i) of project.ProjectAnalyticsRoles">
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            {{ roleSettings.RoleName }}
                                        </label>
                                        <div>
                                            <input :name="'dataType'+i" :id="'dataType1'+i" value="0" type="radio" class="input-checkbox" v-model="roleSettings.DataTypeId" />
                                            <label :for="'dataType1'+i" class="input-checkbox-lbl no-margin-top">График</label>

                                            <input :name="'dataType'+i" :id="'dataType2'+i" value="1" type="radio" class="input-checkbox" v-model="roleSettings.DataTypeId" />
                                            <label :for="'dataType2'+i" class="input-checkbox-lbl no-margin-top">Таблица</label>
                                        </div>
                                    </div>
                                    <div class="form-field">
                                        <input :id="'ReportEnabled' + i" value="true" type="checkbox" class="input-checkbox"
                                               v-model="roleSettings.ReportEnabled" />
                                        <label :for="'ReportEnabled' + i" class="input-checkbox-lbl">Отображение кнопки Отчёт</label>
                                    </div>
                                    <div class="form-field">
                                        <input :id="'SwitcherEnabled' + i" value="true" type="checkbox" class="input-checkbox"
                                               v-model="roleSettings.SwitcherEnabled" />
                                        <label :for="'SwitcherEnabled' + i" class="input-checkbox-lbl">Показывать переключатель руб./шт.</label>
                                    </div>
                                    <div class="form-field">
                                        <input :id="'PeriodsEnabled' + i" value="true" type="checkbox" class="input-checkbox"
                                               v-model="roleSettings.PeriodsEnabled" />
                                        <label :for="'PeriodsEnabled' + i" class="input-checkbox-lbl">Показывать переключатель периода (день/неделя/месяц)</label>
                                    </div>
                                    <div class="form-field">
                                        <input :id="'DetailEnabled' + i" value="true" type="checkbox" class="input-checkbox"
                                               v-model="roleSettings.DetailEnabled" />
                                        <label :for="'DetailEnabled' + i" class="input-checkbox-lbl">Детализация</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="block-in-page closed">
                            <h2 class="margin-bottom-20 block-in-page-collapce">Рейтинг</h2>
                            <div class="block-in-page-detail">
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Название колонки 1
                                    </label>
                                    <input name="AnalyticsBorderColor" placeholder='по умолчанию "ТекМесяцГод"'
                                           v-model="project.RatingColumn1"
                                           :class="['input-text', {'input-error': errors.has('RatingColumn1')}]" type="text">
                                    <span class="field-validation-valid">{{ errors.first('RatingColumn1') }}</span>
                                </div>
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Название колонки 2
                                    </label>
                                    <input name="AnalyticsBorderColor" placeholder='по умолчанию "Всего"'
                                           v-model="project.RatingColumn2"
                                           :class="['input-text', {'input-error': errors.has('RatingColumn2')}]" type="text">
                                    <span class="field-validation-valid">{{ errors.first('RatingColumn2') }}</span>
                                </div>
                                <div class="form-field">
                                    <input id="RatingColumn2AsPercent" name="RatingColumn2AsPercent" value="true"
                                           type="checkbox" class="input-checkbox"
                                           v-model="project.RatingColumn2AsPercent" />
                                    <label for="RatingColumn2AsPercent" class="input-checkbox-lbl">Выводить как %</label>
                                </div>

                                <div class="line-separator margin-bottom-15 margin-top-15"></div>

                                <div class="form-field">
                                    <input id="RatingSwitcherEnabled" name="RatingSwitcherEnabled" value="true"
                                           type="checkbox" class="input-checkbox"
                                           v-model="project.RatingSwitcherEnabled" />
                                    <label for="RatingSwitcherEnabled" class="input-checkbox-lbl">Переключатель отображаемых данных</label>
                                </div>
                                <template v-if="project.RatingSwitcherEnabled">
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Отображать для:
                                        </label>
                                        <div>
                                            <div class="form-field" v-for="(role, i) of rolesOrdered">
                                                <input type="checkbox" class="input-checkbox" value="true"
                                                       :id="'switcherRole' + i"
                                                       :name="'switcherRole' + i"
                                                       v-model="role.Claims"
                                                       :value="bindClaim(claimEnums.ratingSwitcher, getRoleClaim(role, claimEnums.ratingSwitcher))" />
                                                <label :for="'switcherRole' + i" class="input-checkbox-lbl">{{ role.Name }}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <h2>Список для отображения</h2>
                                    <div class="form-field-group" v-for="(item, i) of project.RatingRoles">
                                        <div class="form-field">
                                            <label class="input-text-lbl">
                                                Отображаемое имя
                                            </label>
                                            <input type="text" class="input-text" placeholder="Отображаемое имя"
                                                   :name="'RatingRoleName' + i"
                                                   v-model="item.Name"
                                                   v-validate="'required'"
                                                   :class="[{'input-error': errors.has('RatingRoleName' + i)}]" />
                                            <span class="field-validation-valid"></span>
                                        </div>
                                        <div class="form-field">
                                            <label class="input-text-lbl">
                                                Передаваемое значение (только латиница и цифры)
                                            </label>
                                            <input type="text" class="input-text" placeholder="Передаваемое значение"
                                                   :name="'RatingRoleValue' + i"
                                                   v-model="item.Value"
                                                   data-vv-as="Передаваемое значение"
                                                   v-validate="'required'"
                                                   :class="[{'input-error': errors.has('RatingRoleValue' + i)}]" />
                                            <span class="field-validation-valid">{{ errors.first('RatingRoleValue' + i) }}</span>
                                        </div>
                                        <div class="form-field">
                                            <input value="true" type="radio" class="input-checkbox"
                                                   :id="'RatingRoleValueDefault' + i" name="RatingRoleValueDefault"
                                                   v-model="item.ByDefault" @change="onByDefaultChange(item)" />
                                            <label :for="'RatingRoleValueDefault' + i" class="input-checkbox-lbl">По умолчанию</label>
                                        </div>
                                        <div class="form-field" style="width:35px;min-width:35px;padding-top:23px">
                                            <button type="button" class="btn btn-default btn-img"
                                                    @click.stop="onRemoveRatingRole(i)">
                                                <img src="../../../img/icon-del.png" alt="" />
                                            </button>
                                        </div>
                                    </div>

                                    <div class="line-separator margin-bottom-15 margin-top-15"></div>

                                    <button type="button" class="btn btn-primary margin-top-15 btn-img"
                                            @click="addRatingRole()">
                                        <img src="../../../img/icon-plus-2.png" alt="" />
                                    </button>
                                </template>
                            </div>
                        </div>

                        <div class="block-in-page closed">
                            <h2 class="margin-bottom-20 block-in-page-collapce">Визуальное оформление системы</h2>
                            <div class="block-in-page-detail">
                                <div class="form-field-group">
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Цвет иконок меню на сайте
                                        </label>
                                        <input name="MenuColorSite" placeholder="Например, #FFFFFF"
                                               v-model="project.VisualDesign.MenuColorSite"
                                               :class="['input-text']" type="text">
                                    </div>
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Цвет иконок меню в мобильном приложении на светлой теме
                                        </label>
                                        <input name="MenuColorMobileLight" placeholder="Например, #FFFFFF"
                                               v-model="project.VisualDesign.MenuColorLight"
                                               :class="['input-text']" type="text">
                                    </div>
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Цвет иконок меню в мобильном приложении на темной теме
                                        </label>
                                        <input name="MenuColorMobileDark" placeholder="Например, #FFFFFF"
                                               v-model="project.VisualDesign.MenuColorDark"
                                               :class="['input-text']" type="text">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="block-in-page closed">
                            <h2 class="margin-bottom-20 block-in-page-collapce">{{feedbackPageName}}</h2>
                            <div class="block-in-page-detail">
                                <div class="form-field-group">
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Информационное сообщение
                                        </label>
                                        <textarea maxlength="256" rows="10"
                                                  name="FeedbackInformMessage"
                                                  class="input-memo"
                                                  v-model="project.FeedbackSettings.InformMessage"></textarea>
                                    </div>
                                    <div class="form-field">
                                        <div class="form-field">
                                            <label class="input-text-lbl">
                                                Телефон службы поддержки
                                            </label>
                                            <the-mask :mask="'# (###) ###-##-##'" name="FeedbackPhoneSTP"
                                                      v-model="project.FeedbackSettings.PhoneSTP"
                                                      v-validate="{regex: /^\d{11}$/ }"
                                                      :class="['input-text', {'input-error': errors.has('FeedbackPhoneSTP')}]"
                                                      data-vv-as="Телефон службы поддержки" />
                                            <span class="field-validation-valid">{{ errors.first('FeedbackPhoneSTP') }}</span>
                                        </div>
                                        <div class="form-field">
                                            <label class="input-text-lbl">
                                                Email службы поддержки
                                            </label>
                                            <input name="FeedbackEmail"
                                                   v-model="project.FeedbackSettings.Email"
                                                   v-validate="'email'"
                                                   :class="['input-text', {'input-error': errors.has('FeedbackEmail')}]" type="text">
                                            <span class="field-validation-valid">{{ errors.first('FeedbackEmail') }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </template>

        <popup-window ref="ppSkuFieldSettings" :title="'Настройка отображения полей SKU в отчёте'" :width="800">
            <p class="caption-help">Настройка отображения и использования полей справочника в отчёте в данном проекте</p>
            <table class="table-view" id="tSkuFieldSett">
                <thead class="head-show">
                <tr class="heading">
                    <th>Название поля</th>
                    <th>Осуществлять поиск</th>
                    <th>Сцепить для показа</th>
                </tr>
                </thead>
                <tbody v-if="skuSettings != null && dialogSkuSettings != null">
                    <tr :key="s" v-for="(skuSettingsItem, s) of skuSettingsOrdered">
                        <td>
                            {{ skuSettingsItem.Title }}
                        </td>
                        <td class="bit">
                            <input :id="'list' + s" :name="'list' + s" v-model="skuSettingsItem.search" value="true" type="checkbox" class="input-checkbox" />
                            <label :for="'list' + s" class="input-checkbox-lbl no-text"></label>
                        </td>
                        <td class="bit">
                            <input :id="'det' + s" :name="'det' + s" v-model="skuSettingsItem.attached" value="true" type="checkbox" class="input-checkbox" />
                            <label :for="'det' + s" class="input-checkbox-lbl no-text"></label>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="btns flex margin-top-20" data-toggle="buttons">
                <button type="button" class="btn btn-primary" @click="updateSkuSettingsItem()">Ок</button>
                <button type="button" class="btn" @click="$refs.ppSkuFieldSettings.close()">Отмена</button>
            </div>
        </popup-window>

        <vue-headful title="Проекты" />
    </div>
</template>

<script>
    import { Container, Draggable } from 'vue-smooth-dnd'
    import $ from 'jquery'
    import BackendApi from '../../backendApi'
    import UI from '../../helpers/ui-helpers'
    import moment from 'moment'
    import { RegisterTradePointTypes } from '../../enums'
    import ReportItemsTable from '../../components/ReportItemsTable'
    let backendApi = new BackendApi();

    let defaultPageNames = {
        '/reports/0': 'Добавить отчёт',
        '/': 'Новости',
        '/materials': 'Материалы',
        '/reports': 'Отчёты',
        '/rating': 'Рейтинг',
        '/spend-bonuses': 'Потратить бонусы',
        '/analytics': 'Аналитика',
        '/sku': 'SKU',
        '/motivation': 'Программа мотивации',
        '/faq': 'FAQ',
        '/orders': 'Заказы',
        '/cart': 'Мои заказы',
        '/tasks': 'Задания',
        '/feedback': 'Обратная связь',
        '/my-progress': 'Мои достижения'
    };

    export default {
        name: "project-edit",

        props: ['info'],

        data() {
            return {
                project: null,
                file: null,
                fileStart: null,
                deleteImage: false,
                deleteStartImage: false,
                deletePolicyFile: false,
                policyFile: null,
                deleteRulesFile: false,
                rulesFile: null,
                dataLoadingFrequencies: [
                    { Id: 0, Name: 'Не выбрано' },
                    { Id: 1, Name: '1 день' },
                    { Id: 3, Name: '3 дня' },
                    { Id: 7, Name: '1 неделя' },
                    { Id: 30, Name: '1 месяц' },
                    { Id: 365, Name: '1 год' }
                ],
                activationPeriodTypes: [
                    { Id: 'fact', Name: 'По каждому факту начисления' },
                    { Id: 'sum', Name: 'Суммарно по всем баллам за период' }
                ],
                activationPeriods: [
                    { Id: 'week', Name: 'Неделя' },
                    { Id: 'month', Name: 'Месяц' }
                ],
                activationFromDate: [
                    { Id: 'approved', Name: 'Дата проверки отчета' },
                    { Id: 'report', Name: 'Дата отчёта' }
                ],
                durationPeriods:[
                    { Id: '0', Name: 'Не сгорают' },
                    { Id: '30', Name: '30 дней' },
                    { Id: '90', Name: '90 дней' },
                    { Id: '180', Name: '180 дней' },
                    { Id: '360', Name: '360 дней' }
                ],
                bonusStrategies: [
                    { Id: 'fact', Name: 'По факту отчета' },
                    { Id: 'data', Name: 'По данным' },
                    { Id: 'sp', Name: 'Процедура' },
                    { Id: 'sku', Name: 'В зависимости от SKU'}
                ],
                bonusStrategyAccrualTypes: [
                    { Id: '1', Name: 'Процент от суммы' },
                    { Id: '2', Name: 'Умножить на сумму' }
                ],
                bonusStrategyAccrualValueDate: [],
                bonusStrategyProcedures: [
                    { Id: '', Name: 'Нет данных' }
                ],
                reportSettingsTypes:[
                    { Id: 'select', Name: 'Список' },
                    { Id: 'int', Name: 'Целое число' },
                    { Id: 'decimal', Name: 'Дробное число' },
                    { Id: 'string', Name: 'Строковое значение' },
                    { Id: 'bool', Name: 'Галочка (да или нет)' },
                    { Id: 'sku', Name: 'Список SKU' },
                    { Id: 'date', Name: 'Дата' }
                ],
                additionalValueFeeItems :[
                    { Value: 0.35, Name: '35%' },
                    { Value: 0.13, Name: '13%' },
                    { Value: 0.1, Name: '10%' }
                ],
                filteredAdditionalValueFeeOptions: [],
                skuSettings: [],
                dialogSkuSettings: null,
                currentSkuListSettingItem: null,
                roles: [],
                ozonAccounts: [{ Id: 0, Name: 'Не выбрано' }],
                countries: [],
                RegisterTradePointTypes,
                accrualValueTable: null,
            }
        },

        components: { Container, Draggable, ReportItemsTable },

        computed: {
            rolesOrdered: function () {
                return _.orderBy(this.roles, 'Order');
            },

            pagesOrdered: function () {
                return _.orderBy(this.project.Pages.filter(x => x.PageOrder > 0 && x.Path !== '/reports/0'), 'PageOrder');
            },

            reportAddPage: function(){
                return this.project.Pages.find(x => x.Path === '/reports/0');
            },

            reportSettingsOrdered: function(){
                return _.orderBy(this.project.ReportSettings, 'itemOrder');
            },

            bonusSettingsStr() {
                let vm = this;
                //if (vm.project.bonusSettings.bonusStrategy.type !== 'data' || vm.project.bonusSettings.bonusStrategy.data.accrualType != 1)
                //    vm.project.bonusSettings.bonusStrategy.data.ValueItems = [];
                //else
                if (vm.project.bonusSettings.bonusStrategy.type === 'data' && vm.project.bonusSettings.bonusStrategy.data.accrualType == 1)
                {
                    for (let s of vm.project.bonusSettings.bonusStrategy.data.ValueItems) {
                        s.Id = 0;
                    }
                }
                return JSON.stringify(this.project.bonusSettings);
            },

            reportSettingsStr(){
                for(let s of this.project.ReportSettings){
                    if(s.type === 'bool'){
                        s.options = '["Нет", "Да"]';
                        s.dbType = 'bit';
                    }
                    else if(s.type === 'int' || s.name === 'EquipmentType'|| s.type === 'sku'){
                        s.dbType = 'int';
                    }
                    else if(s.type === 'decimal'){
                        s.dbType = 'decimal(18,2)';
                    }
                    else if(s.type === 'string'){
                        s.dbType = 'nvarchar(256)';
                    }
                    else if(s.type === 'select'){
                        s.dbType = 'nvarchar(256)';
                    }
                    else if(s.type === 'date'){
                        s.dbType = 'date';
                    }
                    delete s.new;
                    if(s.type !== 'sku'){
                        delete s.sku;
                    }
                }
                return JSON.stringify(this.project.ReportSettings);
            },

            bonusStrategyFields(){
                //console.info('bonusStrategyFields length:', this.project.ReportSettings.length);
                return this.project.ReportSettings.filter(x => {
                    return x.type === 'int' || x.type === 'decimal';
                }).map(x => {
                    return {
                        Id: x.name,
                        Name: x.caption }
                });
            },

            bonusStrategySkuFields(){
                return this.project.ReportSettings.filter(x => {
                    return x.type === 'sku';
                }).map(x => {
                    return {
                        Id: x.name,
                        Name: x.caption }
                });
            },

            bonusStrategyDateFields(){
                return this.project.ReportSettings.filter(x => {
                    return x.type === 'date';
                }).map(x => {
                    return {
                        Id: x.name,
                        Name: x.caption }
                });
            },

            tradePointColumnsRequired(){
                return this.project.RegisterSettings.Enabled && this.project.RegisterSettings.RegisterTradePointType === RegisterTradePointTypes.Select &&
                    !this.project.RegisterSettings.TradePointColumns.length;
            },

            visualDesignStr() {
                return JSON.stringify(this.project.VisualDesign);
            },

            skuSettingsOrdered() {
                if (this.dialogSkuSettings == null) {
                    return null;
                }

                return _.orderBy(Object.values(this.dialogSkuSettings.sku), 'SettingsOrder');
            },

            feedbackSettingsStr() {
                return JSON.stringify(this.project.FeedbackSettings);
            },

            feedbackPageName: function () {
                let page = this.project.Pages.filter(x => {
                    return x.Path === '/feedback';
                })[0];
                return (page && page.Name) ? page.Name : 'Обратная связь';
            },

            regFieldsOrdered: function () {
                return _.orderBy(this.project.RegisterSettings.RegFields, 'ItemOrder');
            }
        },

        methods: {
            onCountryChange() {
              this.updateAdditionalValueFeeOptions();
            },

            updateAdditionalValueFeeOptions() {
              if (!this.project || !this.project.CountryId) return;

              switch (this.project.CountryId) {
                case 1: // Россия
                  this.filteredAdditionalValueFeeOptions = this.additionalValueFeeItems.filter(item => item.Value === 0.35 || item.Value === 0.13);
                  break;
                case 2: // Беларусь
                  this.filteredAdditionalValueFeeOptions = this.additionalValueFeeItems.filter(item => item.Value === 0.13);
                  this.project.AdditionalValueFeeValue = 0.13;
                  break;
                case 3: // Казахстан
                  this.filteredAdditionalValueFeeOptions = this.additionalValueFeeItems.filter(item => item.Value === 0.1);
                  this.project.AdditionalValueFeeValue = 0.1;
                  break;
                default:
                  this.filteredAdditionalValueFeeOptions = [];
                  break;
              }
            },

            getDisabledStatus(fieldSettings){
                let strategy = this.project.bonusSettings.bonusStrategy;
                if(strategy.type === 'sku'){
                    if(fieldSettings.name === strategy.data.countFieldName || fieldSettings.name === strategy.data.fieldName){
                        return true;
                    }
                }
                if(strategy.type === 'data'){
                    if(fieldSettings.name === strategy.data.fieldName){
                        return true;
                    }
                    if (strategy.data.accrualType == 1 && fieldSettings.name === strategy.data.accrualValueDate) {
                        return true;
                    }
                }

                return false;
            },

            onSettingsDeletedClick(id, fieldSettings) {
                let input = document.getElementById(id);
                if (input.disabled) {
                    let strategy = this.project.bonusSettings.bonusStrategy;
                    if (strategy.type === 'sku') {
                        if (fieldSettings.name === strategy.data.countFieldName || fieldSettings.name === strategy.data.fieldName) {
                            UI.toastr.error('Поле используется в настройке начисления баллов за отчёт')
                        }
                    }
                    if (strategy.type === 'data') {
                        if (fieldSettings.name === strategy.data.fieldName) {
                            UI.toastr.error('Поле используется в настройке начисления баллов за отчёт')
                        }
                    }
                }
            },

            onSettingsDeletedChange(fieldSettings) {
                if (this.project.bonusSettings.bonusStrategy.type === 'data' && fieldSettings.type === 'date') {
                    this.updateReportSettingsDate();
                }
            },

            bindClaim(claimId, roleClaim){
                return {
                    ClaimId: claimId,
                    Value: roleClaim ? roleClaim.Value : null
                }
            },

            onByDefaultChange(item) {
                for (let r of this.project.RatingRoles) {
                    r.ByDefault = false;
                }
                item.ByDefault = true;
            },

            getRoleClaim(role, claimId){
                return role.Claims.find((val) => val.ClaimId === claimId);
            },

            onDrop(dropResult){
                let vm = this;

                if(dropResult.removedIndex === dropResult.addedIndex){
                    return;
                }

                let temp = _.orderBy(vm.project.Pages.filter(x => x.Path !== '/reports/0'), 'PageOrder');
                let reportAddPage = vm.project.Pages.find(x => x.Path === '/reports/0');

                let itemToAdd;
                if (dropResult.removedIndex != null) {
                    itemToAdd = temp.splice(dropResult.removedIndex, 1)[0];
                }
                if (dropResult.addedIndex !== null) {
                    temp.splice(dropResult.addedIndex, 0, itemToAdd)
                }

                let order = 1;
                temp.forEach((x) => {
                    x.PageOrder = order++;
                });
                if(reportAddPage){
                    temp = [reportAddPage, ...temp];
                }

                vm.project.Pages = temp;
            },

            onReportSettingsDrop(dropResult){
                let vm = this;

                if(dropResult.removedIndex === dropResult.addedIndex){
                    return;
                }

                let temp = _.orderBy(vm.project.ReportSettings, 'itemOrder');
                let itemToAdd;
                if (dropResult.removedIndex != null) {
                    itemToAdd = temp.splice(dropResult.removedIndex, 1)[0];
                }
                if (dropResult.addedIndex !== null) {
                    temp.splice(dropResult.addedIndex, 0, itemToAdd)
                }

                let order = 1;
                temp.forEach((x) => {
                    x.itemOrder = order++;
                });

                vm.project.ReportSettings = temp;
            },

            onPageEdit(page){
                this.project.Pages.forEach((x) => {
                    x.Edited = false;
                });
                page.Edited = true;
            },

            onShowModal(modal) {
                this.$nextTick(() => {
                    this.$refs[modal].show();
                });
            },

            updateSkuSettingsItem(){
                let vm = this;
                for(let s in vm.dialogSkuSettings.sku) {
                    if(vm.currentSkuListSettingItem.sku[s]) {
                        vm.currentSkuListSettingItem.sku[s].search = vm.dialogSkuSettings.sku[s].search;
                        vm.currentSkuListSettingItem.sku[s].attached = vm.dialogSkuSettings.sku[s].attached;
                    }
                    else{
                        vm.currentSkuListSettingItem.sku[s] = {
                            search: vm.dialogSkuSettings.sku[s].search,
                            attached: vm.dialogSkuSettings.sku[s].attached
                        };
                    }
                }
                vm.currentSkuListSettingItem.__ob__.dep.notify();

                this.$refs.ppSkuFieldSettings.close();
            },

            setUpSkuList(settingsItem){
                let vm = this;

                vm.currentSkuListSettingItem = settingsItem;

                for(let s in vm.dialogSkuSettings.sku) {
                    if(vm.currentSkuListSettingItem.sku[s]) {
                        vm.dialogSkuSettings.sku[s].search = vm.currentSkuListSettingItem.sku[s].search;
                        vm.dialogSkuSettings.sku[s].attached = vm.currentSkuListSettingItem.sku[s].attached;
                    }
                }
                vm.dialogSkuSettings.__ob__.dep.notify();

                vm.onShowModal('ppSkuFieldSettings');
            },

            onReportSettingsTypesChange(settings){
                let vm = this;
                if(settings.type === 'sku'){
                    settings.sku = {};
                    for(let s in vm.skuSettings)
                    {
                        settings.sku[s] = {search: false, attached: false};
                        //vm.dialogSkuSettings.sku[s] = {search: false, attached: false};
                    }

                    // не лучший вариант, но пока и не обязательно второе поле
                    let skuSelectCount = this.project.ReportSettings.filter(x => x.type === 'sku').length;
                    if(skuSelectCount === 1){
                        settings.name = 'SkuId'
                    }
                    else {
                        settings.name = 'SkuId' + skuSelectCount;
                    }
                } else{
                    //delete settings.sku;
                }
                vm.updateReportSettingsDate();
            },

            onReportSettingsCaptionChange(settings) {
                let vm = this;
                if (settings.type === 'date') {
                    vm.updateReportSettingsDate();
                }
            },

            addReportSettings(){
                let newOrder = 1;
                this.project.ReportSettings.forEach(x => {
                    if(x.itemOrder != undefined && x.itemOrder > newOrder){
                        newOrder = x.itemOrder + 1;
                    }
                });
                this.project.ReportSettings.push({type:'string', deleted: false, new: true, itemOrder: newOrder});
            },

            onRemoveReportSettings(settings, i) {
                if (settings.type === 'date')
                    this.updateReportSettingsDate();
                //settings.deleted = true;
                this.project.ReportSettings.splice(i, 1);
            },

            updateReportSettingsDate() {
                let vm = this;
                //vm.bonusStrategyAccrualValueDate = [ { Value: 'none', Name: 'Не выбрано' } ];
                vm.bonusStrategyAccrualValueDate = [
                    { Value: 'none', Name: 'Не выбрано' },
                    { Value: 'dateCreate', Name: 'Дата создания' },
                    { Value: 'dateAccept', Name: 'Дата принятия' },
                    { Value: 'dateReport', Name: 'Дата отчета' },
                ];
                for (let s of vm.reportSettingsOrdered) {
                    if (!s.deleted && s.type == 'date' && s.caption && s.name) {
                        vm.bonusStrategyAccrualValueDate.push({ Value: s.name, Name: s.caption });
                    }
                }
            },

            addFirstLaunchSettingsItem(){
                this.project.ProjectFirstLaunchSettings.push({new: true});
            },

            onRemoveFirstLaunchSettings(i){
                this.project.ProjectFirstLaunchSettings.splice(i, 1);
            },

            addPhotoSettings(){
                this.project.ReportPhotoFields.push({
                    Name: 'Новый блок',
                    Required: false
                });
            },

            onRemovePhotoSettings(i) {
                this.project.ReportPhotoFields.splice(i, 1);
            },

            onChangeDate(item, formatted, raw) {
                item[raw] = moment(item[formatted], 'DD.MM.YYYY').format();
            },

            cancel() {
                this.$router.back();
            },

            onRoles(){
                this.$router.push('/projects/' + this.$route.params.id + '/roles/');
            },

            onUsers() {
                this.$router.push('/projects/' + this.$route.params.id + '/users/');
            },

            onTradePoints(){
                this.$router.push('/projects/' + this.$route.params.id + '/trade-points/');
            },

            loadSettings(){
                let vm = this;
                let projectId = parseInt(this.$route.params.id);
                this.callApiWrapper(backendApi.skuSettings(projectId))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки настроек sku');
                        }
                        else {
                            if (resp.data) {
                                //console.info('resp.data', resp.data)
                                let dict = {};
                                for (let s of resp.data) {
                                    if (!dict[s.FieldName]) {
                                        dict[s.FieldName] = s;
                                    }
                                }
                                vm.skuSettings = dict;

                                let sList = {
                                    sku: {

                                    }
                                };
                                for (let s in vm.skuSettings) {
                                    sList.sku[s] = { search: false, attached: false, Title: vm.skuSettings[s].Title, SettingsOrder: vm.skuSettings[s].SettingsOrder  };
                                }
                                vm.dialogSkuSettings = sList;
                            }
                        }
                    });

                vm.accrualValueTable = {
                    bonusSettings: {
                        bonusStrategy: {
                            type: ''
                        },
                        noReport: true,
                        skuView: 'none'
                    },
                    TradePoint: { Id: 0, SkuLink: '' },
                    reportSettings: [],
                    equipmentTypes: [{ Id: 0, Name: '' }],
                    sku: [{ Id: -1, Name: '' }],
                    ReportDate: new Date(),
                    canBeEdited: true,
                    minItems: 0,
                    maxItems: 50,
                    ReportItems: []
                };
                vm.accrualValueTable.reportSettings.push({ name: 'value', type: 'decimal', caption: 'Значение', id: 0 });
                vm.accrualValueTable.reportSettings.push({ name: 'dateBeg', type: 'date', caption: 'Дата начала', id: 1 });
                vm.accrualValueTable.reportSettings.push({ name: 'dateEnd', type: 'date', caption: 'Дата окончания', id: 2 });
            },

            loadRoles(){
                let vm = this;
                return this.callApiWrapper(backendApi.rolesList(this.$route.params.id))
                    .then(function (resp) {
                        if (resp.data) {

                            vm.roles = resp.data.Roles;
                        }
                    })
            },

            loadOzonAccounts() {
                let vm = this;
                return this.callApiWrapper(backendApi.commonOzonAccounts())
                    .then(function (resp) {
                        if (resp.data) {
                            vm.ozonAccounts.push(...resp.data);
                        }
                    })
            },

            loadCountries() {
              let vm = this;
              return this.callApiWrapper(backendApi.commonCountries())
                  .then(function (resp) {
                    if (resp.data) {
                      vm.countries.push(...resp.data);
                    }
                  })
            },

            loadProject() {
                let that = this;
                let id = parseInt(this.$route.params.id);
                if (id === 0) {
                    let defaultPages = [];
                    let order = 1;
                    for(let path in defaultPageNames){
                        defaultPages.push({
                            Path: path,
                            DefaultName: defaultPageNames[path],
                            PageOrder: order++,
                            Edited: false
                        })
                    }

                    this.project = {
                        new: true,
                        ReportSettings: [],
                        bonusSettings: {
                            "activationPeriod": {
                                "type": null,
                                "data": {
                                    "period": null,
                                    "value": 0,
                                    "fromDate": "approved"
                                }
                            },
                            "durationPeriod": null,
                            "bonusStrategy": {
                                "type": null,
                                "data": {
                                    "fieldName": null,
                                    "value": 0,
                                    "accrualType": 1,
                                    "ValueItems": [],
                                    "accrualValueDate": null
                                }
                            }
                        },
                        ReportPhotoFields:[
                            {
                                Name: 'Прикрепите фотоотчет',
                                Required: true
                            }
                        ],
                        ProjectFirstLaunchSettings: [],
                        Pages: defaultPages,
                        RatingRoles: [],
                        ExternalEnabled: false,
                        ExternalVk: false,
                        ExternalGoogle: false,
                        ExternalFacebook: false,
                        RegisterSettings: {
                            AutoConfirmUser: false,
                            Enabled: false,
                            DefaultRoleId: null,
                            RegisterTradePointType: 0,
                            TradePointColumns: [],
                            RegFields: []
                        },
                        ComplimentarySettings:{

                        },
                        RegisterCodeMobile: '',
                        VisualDesign: {},
                        FeedbackSettings: {}
                    };
                    that.GetRegisterCodeMobile();
                    // Установить страну по умолчанию и обновить НДФЛ
                    if (this.countries.length > 0) {
                      this.project.CountryId = this.countries[0].Id;
                      this.updateAdditionalValueFeeOptions();
                    }

                    return new Promise(resolve => resolve());
                }
                else {
                    return backendApi.projectLoad(id).then(function (response) {
                        //console.info('project.edit -> load, response:', response.data);
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при загрузке проекта');
                        }
                        else {
                            let data = response.data;

                            if (data == null) {
                                that.$router.push('/projects');
                            }

                            data.StartDateFormatted = that.formatDate(data.StartDate);
                            data.EndDateFormatted = that.formatDate(data.EndDate);
                            data.FileName = null;
                            data.FileData = null;
                            data.DeleteImage = null;

                            if(data.ComplimentarySettings) {
                              data.ComplimentarySettings.PeriodStartDateFormatted = that.formatDate(data.ComplimentarySettings.PeriodStartDate);
                              data.ComplimentarySettings.PeriodEndDateFormatted = that.formatDate(data.ComplimentarySettings.PeriodEndDate);
                              data.ComplimentarySettings.ExpirationDateFormatted = that.formatDate(data.ComplimentarySettings.ExpirationDate);
                            }

                            data.bonusSettings = JSON.parse(data.BonusSettings || '[]');
                            let rsData = JSON.parse(data.ReportSettings || '[]');
                            let itemOrder = 1;
                            for(let item of rsData){
                                if(typeof item.deleted === 'undefined'){
                                    item.deleted = false;
                                }
                                item.itemOrder = itemOrder;
                                itemOrder++;
                            }
                            data.ReportSettings = rsData;

                            for(let item of data.Pages) {
                                item.DefaultName = defaultPageNames[item.Path];
                                item.Edited = false;
                            }
                            itemOrder = data.Pages.length;
                            for (let path in defaultPageNames) {
                                var newArray = data.Pages.filter(function (f) { return f.DefaultName === defaultPageNames[path] })
                                if (newArray.length === 0) {
                                    data.Pages.push({
                                        Path: path,
                                        DefaultName: defaultPageNames[path],
                                        PageOrder: itemOrder++,
                                        Edited: false
                                    });
                                }
                            }

                            data.AnalyticsReportProcedureType = data.AnalyticsReportProcedureName ? 1 : 0;

                            data.ExternalEnabled = data.ExternalVk || data.ExternalGoogle || data.ExternalFacebook;
                            if (data.VisualDesign)
                                data.VisualDesign = JSON.parse(data.VisualDesign);
                            else
                                data.VisualDesign = {};
                            data.FeedbackSettings = JSON.parse(data.FeedbackSettings || '{}');

                           /* for (let roleSettings of data.ProjectAnalyticsRoles){
                                let role = that.roles.find(x => x.Id === roleSettings.DynamicRoleId);
                                roleSettings.RoleName =
                            }*/
                            if (!data.bonusSettings.bonusStrategy.data.ValueItems)
                                data.bonusSettings.bonusStrategy.data.ValueItems = [];
                            if (!data.bonusSettings.activationPeriod.data.fromDate)
                                data.bonusSettings.activationPeriod.data.fromDate = "approved";

                            that.project = data;
                            that.updateReportSettingsDate();

                            // Установить страну по умолчанию и обновить НДФЛ, если CountryId не задан
                            if (!that.project.CountryId && that.countries.length > 0) {
                              that.project.CountryId = that.countries[0].Id;
                            }
                            that.updateAdditionalValueFeeOptions();
                        }
                    })
                }
            },

            saveProject() {
                let vm = this;

                this.$validator.validate().then(result => {
                    if (!result) {
                        if (vm.project.RegisterSettings.Enabled && vm.project.RegisterSettings.RegisterTradePointType === RegisterTradePointTypes.Select &&
                            !vm.project.RegisterSettings.TradePointColumns.length) {
                            UI.toastr.error('Выберите хотя бы одно поле из адрески');
                        } else {
                            UI.toastr.error('Проверьте введённые данные');
                        }
                    }
                    else {
                        if ((vm.project.bonusSettings.bonusStrategy.type === 'data' && vm.project.bonusSettings.bonusStrategy.data.accrualType === '1')
                            && vm.project.bonusSettings.bonusStrategy.data.accrualValueDate !== 'none') {
                            if (vm.project.bonusSettings.bonusStrategy.data.ValueItems.length > 0) {
                                for (let s of vm.project.bonusSettings.bonusStrategy.data.ValueItems) {
                                    for (let field of s.Fields) {
                                        if (field.Value == null || field.Value.length === 0) {
                                            UI.toastr.error('Проверьте введённые данные таблицы, все поля обязательны для заполнения!');
                                            return;
                                        }
                                        if (field.Name === 'dateBeg')
                                            s.Id = moment(field.Value, 'DD.MM.YYYY').format();
                                    }
                                }
                                let itemsOrdered = _.orderBy(vm.project.bonusSettings.bonusStrategy.data.ValueItems, 'Id');
                                let dateBeg = itemsOrdered[0].Id;
                                let todayDate = moment(new Date()).format();
                                if (dateBeg > todayDate) {
                                    UI.toastr.error('Проверьте введённые данные таблицы, первая дата должна быть не позднее текущей!');
                                    return;
                                }
                                let dateEnd = moment(dateBeg).add(-1, 'days').format();
                                let diffDays = 0;
                                for (let s of itemsOrdered) {
                                    dateBeg = s.Id;
                                    diffDays = moment(dateBeg).diff(moment(dateEnd), 'days');
                                    if (diffDays < 1) {
                                        UI.toastr.error('Проверьте введённые данные таблицы, имеется перекрестный период!');
                                        return;
                                    }
                                    if (diffDays > 1) {
                                        UI.toastr.error('Проверьте введённые данные таблицы, имеется окно между периодами!');
                                        return;
                                    }
                                    dateEnd = moment(s.Fields[2].Value, 'DD.MM.YYYY').format();
                                    if (dateBeg > dateEnd) {
                                        UI.toastr.error('Проверьте введённые данные таблицы, дата начала не может быть позднее даты окончания!');
                                        return;
                                    }
                                    s.Id = 0;
                                }
                                if (dateEnd < todayDate) {
                                    UI.toastr.error('Проверьте введённые данные таблицы, конечная дата должна быть позднее текущей!');
                                    return;
                                }
                            } else {
                                UI.toastr.error('Проверьте введённые данные таблицы, необходимо добавить хотя бы одну строку!');
                                return;
                            }
                        }
                        var reg = /^#([0-9a-f]{3}){1,2}$/i;
                        if (vm.project.VisualDesign.MenuColorSite && !reg.test(vm.project.VisualDesign.MenuColorSite)) {
                            UI.toastr.error('Проверьте введённые данные, цвет иконок меню не является цветом!');
                            return;
                        }
                        if (vm.project.VisualDesign.MenuColorLight && !reg.test(vm.project.VisualDesign.MenuColorLight)) {
                            UI.toastr.error('Проверьте введённые данные, цвет иконок меню не является цветом!');
                            return;
                        }
                        if (vm.project.VisualDesign.MenuColorDark && !reg.test(vm.project.VisualDesign.MenuColorDark)) {
                            UI.toastr.error('Проверьте введённые данные, цвет иконок меню не является цветом!');
                            return;
                        }

                        UI.blockUI('.page-content', 'Сохранение...');

                        // that.project.StartDate = moment(that.project.StartDateFormatted, 'DD.MM.YYYY').format();
                        // that.project.EndDate = moment(that.project.EndDateFormatted, 'DD.MM.YYYY').format();

                        let saveObj = Object.assign({}, vm.project, {
                            DeleteImage: vm.deleteImage,
                            DeleteStartImage: vm.deleteStartImage,
                            DeletePolicyFile: vm.deletePolicyFile,
                            DeleteRulesFile: vm.deleteRulesFile
                        });
                        saveObj.BonusSettings = vm.bonusSettingsStr;
                        saveObj.ReportSettings = vm.reportSettingsStr;
                        saveObj.PhotoSettings = vm.photoSettingsStr;
                        saveObj.VisualDesign = vm.visualDesignStr;
                        saveObj.FeedbackSettings = vm.feedbackSettingsStr;

                        for(let x of saveObj.ProjectFirstLaunchSettings){
                            if(x.file != null){
                                x.FileTitle = x.file.name;
                            }
                        }
                        if(vm.project.AnalyticsReportProcedureType === 0){
                            saveObj.AnalyticsReportProcedureName = null;
                        }
                        saveObj.DynamicRoles = vm.roles.filter((x) => {
                            return x.Claims.some(y => y.ClaimId === vm.claimEnums.ratingSwitcher);
                        }).map(x => x.Id);

                        delete saveObj.bonusSettings;

                        if(!saveObj.ExternalEnabled){
                            saveObj.ExternalVk = saveObj.ExternalGoogle = saveObj.ExternalFacebook = false;
                        }

                        backendApi.projectSave(saveObj).then(function (response) {
                            //console.info('details -> projectSave, response:', response.data);
                            if (response.hasError) {
                                if(response.status === 401){
                                    UI.toastr.error('Недостаточно прав');
                                }
                                else{
                                    UI.toastr.error('Ошибка при сохранении проекта');
                                }
                                UI.unblockUI('.page-content');
                            } else {
                                UI.toastr.success('Успешно сохранено');

                                if(vm.project.new){
                                    UI.unblockUI('.page-content');
                                    vm.$router.push('/projects');
                                }
                                else {
                                    vm.loadProject().then(() => {
                                        UI.unblockUI('.page-content');
                                    });
                                }
                            }
                        });
                    }
                });
            },

            deleteProject(){
                if(confirm('Вы уверены что хотите удалить проект?')) {
                    UI.blockUI('.page-content', 'Удаление...');
                    let vm = this;

                    backendApi.projectDelete(vm.$route.params.id).then(function (response) {
                        UI.unblockUI('.page-content');
                        if (response.hasError) {
                            if (response.status === 401) {
                                UI.toastr.error('Недостаточно прав');
                            }
                            else {
                                UI.toastr.error('Ошибка при удалении проекта');
                            }
                        } else {
                            UI.toastr.success('Прокт успешно удалён');
                            vm.$router.push('/projects');
                        }
                    });
                }
            },

            removeImage(){
                this.deleteImage = true;
            },

            removeStartImage(){
                this.deleteStartImage = true;
            },

            removeLaunchSettingsImage(launchSettings, i){
                launchSettings.deleteImage = true;
                this.$set(this.project.ProjectFirstLaunchSettings, i, launchSettings);
            },

            onLaunchSettingsImageChange($event, i) {
                let vm = this;
                if ($event.target.files[0].size > 5 * 1024 * 1024) {
                    UI.toastr.error('Превышен размер. Выберите другой файл');
                    //$('[name="dropFiles"]').val('');
                } else {
                    vm.project.ProjectFirstLaunchSettings[i].file = $event.target.files[0];
                    //vm.project.ProjectFirstLaunchSettings[i].FileTitle = $event.target.files[0].name;
                    vm.project.ProjectFirstLaunchSettings[i].deleteImage = false;
                    vm.$set(vm.project.ProjectFirstLaunchSettings, i, vm.project.ProjectFirstLaunchSettings[i]);

                    let reader = new FileReader();
                    reader.onload = function (e) {
                        vm.project.ProjectFirstLaunchSettings[i].FileData = e.target.result;
                        vm.$set(vm.project.ProjectFirstLaunchSettings, i, vm.project.ProjectFirstLaunchSettings[i]);
                    };
                    reader.readAsDataURL($event.target.files[0]);
                }
            },

            addRatingRole(){
                this.project.RatingRoles.push({
                    Name: 'Новая роль',
                    Value: null,
                    Default: false
                });
            },

            onRemoveRatingRole(i) {
                this.project.RatingRoles.splice(i, 1);
            },

            GetRegisterCodeMobile() {
                let vm = this;
                this.callApiWrapper(backendApi.projectRegisterCode())
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время получения кода');
                        }
                        else {
                            vm.project.RegisterCodeMobile = resp.data;
                        }
                        console.info('GetRegisterCodeMobile', resp.data, vm.project.RegisterCodeMobile);
                    });
            },

            onRegFieldsDrop(dropResult) {
                let vm = this;

                if(dropResult.removedIndex === dropResult.addedIndex) {
                    return;
                }

                let temp = _.orderBy(vm.project.RegisterSettings.RegFields, 'ItemOrder');
                let itemToAdd;
                if(dropResult.removedIndex != null) {
                    itemToAdd = temp.splice(dropResult.removedIndex, 1)[0];
                }
                if(dropResult.addedIndex !== null) {
                    temp.splice(dropResult.addedIndex, 0, itemToAdd)
                }

                let order = 1;
                temp.forEach((x) => {
                    x.ItemOrder = order++;
                });

                vm.project.RegisterSettings.RegFields = temp;
            },

            onRemoveRegField(i) {
                this.project.RegisterSettings.RegFields.splice(i, 1);
            },

            addRegField() {
                if(this.project.RegisterSettings.RegFields.length > 9)
                    return;
                let newOrder = 1;
                this.project.RegisterSettings.RegFields.forEach(x => {
                    if(x.ItemOrder != undefined && x.ItemOrder >= newOrder) {
                        newOrder = x.ItemOrder + 1;
                    }
                });
                this.project.RegisterSettings.RegFields.push({FieldType: 'string', Deleted: false, new: true, ItemOrder: newOrder});
            },
        },

        mounted() {
            let vm = this;

            UI.blockUI('.page-content', 'Загрузка...');

            Promise.all([vm.loadSettings(), vm.loadRoles(), vm.loadOzonAccounts(), vm.loadCountries()]).then(function() {

                vm.loadProject().then(() => {
                    UI.unblockUI('.page-content');

                    vm.updateAdditionalValueFeeOptions(); // Обновить значения НДФЛ после загрузки проекта

                    vm.$nextTick(() => {

                        $('body').on('click', function () {
                            vm.project.Pages.forEach((x) => {
                                x.Edited = false;
                            })
                        });

                    });
                });

            });

            $(document).on('click', '.block-in-page-collapce', function () {
                UI.block_collapse(this);
            });

            $(document).on('change', '[name="dropFiles"]', function () {
                if (this.files && this.files[0]) {
                    if(this.files[0].size > 5*1024*1024)
                    {
                        UI.toastr.error('Превышен размер. Выберите другой файл');
                        $('[name="dropFiles"]').val('');
                    }else{
                        vm.file = this.files[0];
                        vm.project.FileName = this.files[0].name;
                        vm.project.DeleteImage = false;

                        let reader = new FileReader();
                        reader.onload = function (e) {
                            vm.project.FileData = e.target.result;
                        };
                        reader.readAsDataURL(this.files[0]);
                    }
                }
            });

            $(document).on('change', '[name="dropFilesStart"]', function () {
                if (this.files && this.files[0]) {
                    if(this.files[0].size > 5*1024*1024)
                    {
                        UI.toastr.error('Превышен размер. Выберите другой файл');
                        $('[name="dropFilesStart"]').val('');
                    }else{
                        vm.fileStart = this.files[0];
                        vm.project.StartImageName = this.files[0].name;
                        vm.project.DeleteStartImage = false;

                        let reader = new FileReader();
                        reader.onload = function (e) {
                            vm.project.StartImageData = e.target.result;
                        };
                        reader.readAsDataURL(this.files[0]);
                    }
                }
            });

            $(document).on('change', '[name="dropFiles2"]', function () {
                if (this.files && this.files[0]) {
                    if(this.files[0].size > 5*1024*1024)
                    {
                        UI.toastr.error('Превышен размер. Выберите другой файл');
                        $('[name="dropFiles2"]').val('');
                    }else{
                        vm.policyFile = this.files[0];
                        vm.project.PolicyFileName = this.files[0].name;
                        vm.project.DeletePolicyFile = false;

                        let reader = new FileReader();
                        reader.onload = function (e) {
                            vm.project.PolicyFileData = e.target.result;
                        };
                        reader.readAsDataURL(this.files[0]);
                    }
                }
            });

            $(document).on('change', '[name="dropFiles3"]', function () {
                if (this.files && this.files[0]) {
                    if(this.files[0].size > 5*1024*1024)
                    {
                        UI.toastr.error('Превышен размер. Выберите другой файл');
                        $('[name="dropFiles3"]').val('');
                    }else{
                        vm.rulesFile = this.files[0];
                        vm.project.RulesFileName = this.files[0].name;
                        vm.project.DeleteRulesFile = false;

                        let reader = new FileReader();
                        reader.onload = function (e) {
                            vm.project.RulesFileData = e.target.result;
                        };
                        reader.readAsDataURL(this.files[0]);
                    }
                }
            });

        },

        destroyed(){
            $(document).off('change', '[name="dropFiles"]');
            $(document).off('change', '[name="dropFiles2"]');
            $(document).off('change', '[name="dropFiles3"]');
            $(document).off('change', '[name="dropFilesStart"]');
            $(document).off('click', '.block-in-page-collapce');
        }
    }
</script>

<style scoped>
    .draggable-item.no-drag{ cursor: default; }
    .block-in-page.opened > .block-in-page-detail{
        min-height: 250px;
    }
    .form-field.form-field-auto{ width: auto;}
</style>


// WEBPACK FOOTER //
// Content/src/views/edit/ProjectEdit.vue